<template>
  <d2-container class="test">
    <!-- 表格头部搜索 -->
    <template slot="header">
      <div style="width: 73%; display: flex; float: left; height: 48px">
        <span align="right" style="
            align: right;
            display: inline-block;
            width: 100px;
            line-height: 48px;
          ">关键字</span>
        <div style="padding: 8px 0px; width: 80%">
          <el-input clearable @keyup.enter.native="search()" style="margin-left: 10px; height: 48px" class="filter-item"
            placeholder="案号，调解号，系统编号，批次号，当事人，卡号" v-model="CaseInfo.keyWord" size="small">
          </el-input>
        </div>
      </div>
      <el-collapse class="test" v-model="activeName" ref="coll">
        <el-collapse-item name="1">
          <template slot="title">
            <div style="width: 100%; display: flex; justify-content: start">
              <div style="text-align: center">
                <el-button style="width: 5rem" class="filter-item" type="primary" round icon="search"
                  @click.stop="search()" size="small">搜索</el-button>
                <el-button style="width: 5rem" class="filter-item" type="danger" round icon="search"
                  @click.stop="resetTemp()" size="small">重置</el-button>
                <el-button style="width: 5rem" class="filter-item" type="primary" plain round icon="search"
                  size="small">更多条件</el-button>
                <!-- @click="titleBlur" -->
              </div>
            </div>
          </template>
          <div style="display: flex; justify-content: start">
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">委托日期</span>
                <el-date-picker type="daterange" @change="search()" style="width: 70%; margin-left: 10px"
                  range-separator="至" format="yyyyMMdd" value-format="yyyy-MM-dd" v-model="CaseInfo.entrustmentDate"
                  start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">提交法院日期</span>
                <el-date-picker type="daterange" style="width: 70%; margin-left: 10px" range-separator="至"
                  format="yyyyMMdd" value-format="yyyy-MM-dd" v-model="CaseInfo.courtSubDate" start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">立案日期</span>

                <el-date-picker @change="changeLian" @keyup.enter.native="search()"
                  style="width: 70%; margin-left: 10px" v-model="value1" type="daterange" range-separator="至"
                  value-format="yyyy-MM-dd" format="yyyyMMdd" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>


          </div>

          <div style="display: flex; justify-content: start">
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">调解成功时间</span>
                <el-date-picker @change="changeMediateTime" @keyup.enter.native="search()"
                  style="width: 70%; margin-left: 10px" v-model="value2" format="yyyyMMdd" value-format="yyyy-MM-dd"
                  type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">开庭日期</span>
                <el-date-picker type="daterange" style="width: 70%; margin-left: 10px" range-separator="至"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="CaseInfo.trialDate" start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">判决时间</span>

                <el-date-picker @change="changeJudgeTime" @keyup.enter.native="search()"
                  style="width: 70%; margin-left: 10px" v-model="value3" type="daterange" format="yyyyMMdd"
                  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>


          </div>

          <div style="display: flex; justify-content: start">
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">执行立案日期</span>
                <el-date-picker type="daterange" style="width: 70%; margin-left: 10px" range-separator="至"
                  format="yyyyMMdd" value-format="yyyy-MM-dd" v-model="CaseInfo.exeFilingDate" start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>

            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">
                  案件状态</span>
                <el-select @keyup.enter.native="search()" clearable multiple v-model="CaseInfo.caseStatus"
                  placeholder="请选择" style="width: 70%; margin-left: 10px; height: auto">
                  <el-option v-for="item in caseStatus" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">
                  代理律师</span>
                <el-select @keyup.enter.native="search()" clearable v-model="CaseInfo.agent" placeholder="请选择"
                  auto-complete="" style="width: 70%; margin-left: 10px">
                  <el-option v-for="item in agent" :key="item.value" :label="item.label" :value="item.label">
                  </el-option>
                </el-select>
              </div>
            </div>


          </div>

          <div style="display: flex; justify-content: start">
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">原告</span>

                <el-select @keyup.enter.native="search()" clearable v-model="CaseInfo.plaintiffName" placeholder="请选择"
                  style="width: 70%; margin-left: 10px">
                  <el-option v-for="item in plaintiffName" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">受理法院</span>
                <el-select @keyup.enter.native="search()" clearable="" v-model="CaseInfo.courtName" placeholder="请选择"
                  style="width: 70%; margin-left: 10px">
                  <el-option v-for="item in courtName" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">案由</span>

                <el-select @keyup.enter.native="search()" clearable v-model="CaseInfo.cause" placeholder="选择案由"
                  style="width: 70%; margin-left: 10px">
                  <el-option v-for="item in causeList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: start">
            <div style="width: 33%; margin-top: 10px">
              <div style="display: flex; padding: 0px" class="jfsj">
                <span align="right" style="display: inline-block; width: 100px; line-height: 40px">案件类型</span>
                <el-select @keyup.enter.native="search()" clearable v-model="CaseInfo.caseType" placeholder="选择案由"
                  style="width: 70%; margin-left: 10px">
                  <el-option label="全流程" value="全流程"></el-option>
                  <el-option label="仅执行" value="仅执行"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div style="display: flex"></div>
    </template>

    <div style="display: flex">
      <el-button style="margin-left: 50px; height: 30px" class="filter-item" type="primary"
        v-permission:function="['czCaseInfoManager_btn_add']" @click="showCreateCase" size="small">创建案件</el-button>

      <!-- <el-upload ref="upload" :on-change="singFileChange" :action="getTableUrl()" :http-request="singleUploadFile"
        multiple :file-list="fileList" :limit="100">
        <el-button type="primary" size="small" style="margin-left: 50px">
          导入预录案件 <i class=""></i>
        </el-button>
      </el-upload> -->

      <!-- 批量操作 -->
      <el-dropdown size="small" type="primary" @command="handleCommand" style="margin-left: 50px">
        <el-button type="primary" size="small" v-permission:function="['czCaseInfoManager_batch_btn']">
          批量操作 <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="batchBackCase"
            v-permission:function="['czCaseInfoManager_batch_backCase']">批量退案</el-dropdown-item>
          <el-dropdown-item command="setAgent"
            v-permission:function="['czCaseInfoManager_batch_setAgent']">批量设置代理人</el-dropdown-item>
          <!-- v-permission:function="['czCaseInfoManager_batch_register']" -->
          <el-dropdown-item v-permission:function="['czCaseInfoManager_batch_register']"
            command="batchRegister">批量立案</el-dropdown-item>
          <el-dropdown-item command="setStatus"
            v-permission:function="['czCaseInfoManager_batch_setStatus']">批量修改案件状态</el-dropdown-item>
          <el-dropdown-item command="batchDelete"
            v-permission:function="['czCaseInfoManager_batch_delCase']">批量删除案件</el-dropdown-item>
          <el-dropdown-item command="hearing"
            v-permission:function="['czCaseInfoManager_batch_setTrial']">批量设置开庭时间</el-dropdown-item>
          <el-dropdown-item command="settleDate" v-permission:function="['czCaseInfoManager_batch_settleDate']">
            批量设置结算日期</el-dropdown-item>
          <el-dropdown-item command="notes">批量备注</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- 导出文书 -->
      <el-dropdown @command="handleCommand">
        <el-button type="primary" size="small" style="margin-left: 50px"
          v-permission:function="['czCaseInfoManager_batch_btn']">
          导出 <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu>
          <el-dropdown-item command="batchCreateDoc"
            v-permission:function="['czCaseInfoManager_batch_expDoc']">批量生成文书</el-dropdown-item>
          <el-dropdown-item command="createGaoZhouDoc"
            v-permission:function="['czCaseInfoManager_createGaoZhouDoc']">生成高州起诉状</el-dropdown-item>
          <el-dropdown-item command="expWebExcel"
            v-permission:function="['czCaseInfoManager_batch_expWebExcel']">生成诉讼网-起诉表格</el-dropdown-item>
          <el-dropdown-item command="expExeExcel"
            v-permission:function="['czCaseInfoManager_batch_expWebExcel']">生成诉讼网-执行表格</el-dropdown-item>
          <el-dropdown-item command="createConstructionTable" v-permission:function="[
            'czCaseInfoManager_createConstructionTable',
          ]">生成建行呈批表</el-dropdown-item>
          <el-dropdown-item command="exportInnerDoc"
            v-permission:function="['czCaseInfoManager_btn_exp']">导出内部台账</el-dropdown-item>
          <el-dropdown-item command="exportBatchNumber"
            v-permission:function="['czCaseInfoManager_batch_batchNumber']">导出批次案件处理详情</el-dropdown-item>
          <el-dropdown-item command="exportBankDoc"
            v-permission:function="['czCaseInfoManager_batch_expBankLedger']">导出银行台账</el-dropdown-item>
          <el-dropdown-item command="expLawyerExcel">导出律师台账</el-dropdown-item>
          <el-dropdown-item command="expProcessingFeeExcel">导出受理费明细清单</el-dropdown-item>
          <el-dropdown-item command="expDiaodang"
            v-permission:function="['czCaseInfoManager_batch_expDiaodang']">导出开庭调档清单</el-dropdown-item>
          <el-dropdown-item command="expSettleExcel"
            v-permission:function="['czCaseInfoManager_exp_settleExcel']">导出结算表</el-dropdown-item>
          <el-dropdown-item command="expPanJueExcel"
            v-permission:function="['czCaseInfoManager_exp_panJueExcel']">导出判决文书表</el-dropdown-item>
          <el-dropdown-item command="exByJieSuan"
            v-permission:function="['czCaseInfoManager_batch_expBankLedger']">导出新银行委外台账</el-dropdown-item>
          <el-dropdown-item command="exByGuiDangJiaoJie"
            v-permission:function="['czCaseInfoManager_batch_expBankLedger']">导出归档交接表</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- 导入  -->
      <el-dropdown size="small" type="primary" @command="handleCommand" style="margin-left: 50px"
        v-permission:function="['czCaseInfoManager_batch_inp']">
        <el-button type="primary" size="small">
          导入 <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="batchUpdateSettleDate"
            v-permission:function="['czCaseInfoManager_batch_inp_settle']">导入结算登记表</el-dropdown-item>
          <el-dropdown-item command="batchUpdateMaterial"
            v-permission:function="['czCaseInfoManager_batch_inp_material']">导入主档材料-识别</el-dropdown-item>
          <el-dropdown-item command="importExeCaseExcel"
            v-permission:function="['czCaseInfoManager_importExeCaseExcel']">导入仅执行案件</el-dropdown-item>
        </el-dropdown-menu>



      </el-dropdown>

      <el-dialog title="上传文件" :visible.sync="uploadExcelFileVisible">
        <el-row v-if="uploadType == 'batchUpdateMaterial'">
          <el-select v-model="uploadExcelBank" clearable placeholder="请选择">
            <el-option label="中国农业银行" value="中国农业银行"></el-option>
            <el-option label="中国银行" value="中国银行"></el-option>
            <el-option label="农行-金融借款合同" value="农行金融借款合同"></el-option>
          </el-select>
        </el-row>
        <el-row style="margin-top: 20px" v-if="uploadExcelBank == '中国银行' && uploadType == 'batchUpdateMaterial'">
          <span>
            身份证页：
            <el-input-number v-model="idCardPageNum" :min="1" :max="100" label="输入页码"></el-input-number>
          </span>
        </el-row>
        <el-row v-if="uploadType == 'importExeCaseExcel'" style="margin-bottom: 20px;">
          <el-link @click="downloadTemplate('执行案件导入模板')" target="_blank">执行案件导入模板.xlxs</el-link>
        </el-row>
        <el-row v-if="uploadType == 'batchUpdateSettleDate'" style="margin-bottom: 20px;">
          <el-link @click="downloadTemplate('结算导入模板')" target="_blank">结算导入模板.xlxs</el-link>
        </el-row>
        <el-row v-if="uploadType == 'batchUpdateSettleDate' || uploadType == 'importExeCaseExcel'">
          <el-button type="primary" @click="uploadSettleExcelClick()">选择文件</el-button>
        </el-row>
        <el-upload ref="uploadSettleExcel" v-show="false" :on-change="singFileChange" :action="getSettleUrl()"
          :http-request="uploadExcelFile" multiple :file-list="fileList" :limit="1">
          <el-button ref="uploadBtn" class="upload-button" type="primary" size="small" style="margin-left: 50px">
            导入结算表 <i class=""></i>
          </el-button>
        </el-upload>
        <span slot="footer" class="dialog-footer" v-if="uploadType == 'batchUpdateMaterial'">
          <el-button @click="uploadExcelFileVisible = false">取 消</el-button>
          <el-button type="primary" @click="uploadSettleExcelClick()">确 定</el-button>
        </span>
      </el-dialog>


      <div class="select_btn"></div>

      <span style="margin-left: 50px"> 表格高度： </span>
      <el-input style="width: 10%; height: 60px" type="number" v-model="tableHeight" @input="setTableHeight"
        placeholder="请输入内容"></el-input>
    </div>

    <!-- 下载批次号表格 -->
    <el-dialog title="导出批次案件处理详情" :visible.sync="batchDialog" :close-on-click-modal="false" width="30%" center>
      <div id="paymentDate">
        <el-input class="filter-item" style="margin-top: 20px" placeholder="请输入批次号，多个批次号用逗号隔开" v-model="batchNumber"
          clearable>
        </el-input>
      </div>
      <div style="width: 250px; margin: 0 auto; margin-top: 20px">
        <el-button type="primary" style="width: 100px" @click="exportBatchNumber">确定</el-button>
        <el-button style="width: 100px; margin-left: 40px" @click="batchDialog = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 被告补录 -->
    <el-dialog title="被告补录" :visible.sync="addSingleDefendantDialog" :close-on-click-modal="false" width="30%" center>
      <el-upload ref="upload1" class="upload-decmo" :on-change="fileChange" :action="getSingleloadUrl()"
        :http-request="HttpUploadFile" multiple :auto-upload="false" :limit="5" :file-list="fileList">
        <div style="position: absolute; left: 50%; transform: translateX(-50%)">
          <el-button size="small" type="primary">点击上传</el-button>
        </div>
        <div slot="tip" class="el-upload__tip" style="margin: 50px auto; text-align: center">
          只能上传jpg/png文件
        </div>
      </el-upload>
      <div style="width: 250px; margin: 0 auto">
        <el-button type="primary" style="width: 100px" @click="addSingleDefendant()">确定</el-button>
        <el-button style="width: 100px; margin-left: 40px" @click="addSingleDefendantDialog = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 案件列表 -->
    <el-table v-loading.body="listLoading" border type="index" :data="list" size="small" stripe :height="tableHeight"
      row-key highlight-current-row @selection-change="handleSelectionChange"
      style="width: 100vw; margin-top: 4px; overflow: auto">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column width="50" align="center" label="勾选序号">
        <template slot-scope="scope">
          <span>{{ scope.row.number }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" align="center" label="系统编号/批次号">
        <template slot-scope="scope">
          <div>{{ scope.row.id }}</div>
          <div>{{ scope.row.batchId }}</div>
        </template>
      </el-table-column>

      <el-table-column width="150" align="center" label="案由/法院名称">
        <template slot-scope="scope">
          <div>
            <el-link type="danger" disabled :underline="false">{{
              scope.row.cause
            }}</el-link>
          </div>
          <div>{{ scope.row.courtName }}</div>
        </template>
      </el-table-column>
      <el-table-column width="200" align="center" label="相关案号">
        <template slot-scope="scope">
          <div>{{ scope.row.registerCode }}</div>
          <div>{{ scope.row.exeCode }}</div>
        </template>
      </el-table-column>
      <el-table-column width="200" align="center" label="当事人">
        <template slot-scope="scope">
          <el-link :underline="false" @click="showEditPage(scope.$index, scope.row)">
            <div style="font-size: 12px">{{ scope.row.plaintiffName }}</div>
          </el-link>
          <el-link type="primary" :underline="false" @click="showEditPage(scope.$index, scope.row)">
            <div>{{ scope.row.defendantName }}</div>
          </el-link>
        </template>
      </el-table-column>

      <el-table-column width="120" align="center" label="案件状态">
        <div slot-scope="scope">
          <el-tag v-if="
            scope.row.caseStatus == '未处置' || scope.row.caseStatus == '异常'
          " type="info">{{ scope.row.caseStatus }}</el-tag>
          <el-tag v-else-if="
            scope.row.caseStatus == '处置中' ||
            scope.row.caseStatus == '提交诉讼服务网' ||
            scope.row.caseStatus == '提交法院'
          " type="warning">{{ scope.row.caseStatus }}</el-tag>
          <el-tag v-else-if="
            scope.row.caseStatus == '已完成' ||
            scope.row.caseStatus == '已撤诉' ||
            scope.row.caseStatus == '已退案'
          " type="success">{{ scope.row.caseStatus }}</el-tag>
          <el-tag v-else-if="
            scope.row.caseStatus == '调解中' ||
            scope.row.caseStatus == '调解成功' ||
            scope.row.caseStatus == '调解方案履行中'
          " type="primary">{{ scope.row.caseStatus }}</el-tag>
          <el-tag v-else type="danger">{{ scope.row.caseStatus }}</el-tag>
          <div v-if="scope.row.caseStatus == '已撤诉'">
            {{ scope.row.dropLawsuitReason }}
          </div>
          <div v-if="scope.row.caseStatus == '已退案'">
            {{ scope.row.withdrawalReason }}
          </div>
        </div>
      </el-table-column>
      <el-table-column width="100" align="center" label="归档状态">
        <template slot-scope="scope">
          <span>{{ scope.row.archivingStatus }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" align="center" label="标的">
        <template slot-scope="scope">
          <span>{{ scope.row.underlyingAmount }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" align="center" label="备注">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" align="center" label="卷宗材料数量">
        <template v-if="scope.row.czCaseFilesCount > 0" slot-scope="scope">
          <span>
            <el-popover placement="right" width="100%" max-height="250" trigger="click">
              <el-table :data="caseFilesList" border>
                <el-table-column width="100" property="id" label="文件编号"></el-table-column>
                <el-table-column width="100" property="documentType" label="归档类型"></el-table-column>
                <el-table-column width="300" property="fileName" label="文件名"></el-table-column>
                <el-table-column width="100" property="createTime" label="上传时间"></el-table-column>
                <el-table-column width="100">
                  <template slot-scope="fileItem">
                    <el-button @click="previewFile(fileItem.row.id)" style="text-align: center;width:100%;"
                      type="text">预览</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button slot="reference" @click="getFileList(scope.row.id)">
                <el-link type="primary">{{ scope.row.czCaseFilesCount + '件' }}</el-link></el-button>
            </el-popover>
          </span>
        </template>
      </el-table-column>

      <el-table-column width="120" align="center" label="立案日期" sortable prop="filingDate" column-key="filingDate">
        <template slot-scope="scope">
          <span>{{ scope.row.filingDate }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" align="center" label="调解成功日期" sortable prop="mediationSuccessDate"
        column-key="mediationSuccessDate">
        <template slot-scope="scope">
          <span>{{ scope.row.mediationSuccessDate }}</span>
        </template>
      </el-table-column>
      <el-table-column width="140" align="center" label="开庭时间" sortable prop="trialDate" column-key="trialDate">
        <template slot-scope="scope">
          <span>{{ scope.row.trialDate }}</span>
        </template>
      </el-table-column>
      <el-table-column width="160" align="center" label="已登记结算日期">
        <template slot-scope="scope">
          <div v-if="scope.row.settleDateFiling !== undefined">
            <el-tag size="mini">立案：{{ scope.row.settleDateFiling }}</el-tag>
          </div>
          <div v-if="scope.row.settleDateDecision !== undefined">
            <el-tag size="mini" type="danger">调解/判决/撤诉：{{ scope.row.settleDateDecision }}</el-tag>
          </div>
          <div v-if="scope.row.settleDateApplyExecution !== undefined">
            <el-tag size="mini" type="warning">申请执行：{{ scope.row.settleDateApplyExecution }}</el-tag>
          </div>
          <div v-if="scope.row.settleDateExecution !== undefined">
            <el-tag size="mini" type="success">执行结案：{{ scope.row.settleDateExecution }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="110" align="center" label="委托日期" sortable prop="entrustmentDate"
        column-key="entrustmentDate">
        <template slot-scope="scope">
          <span>{{ scope.row.entrustmentDate }}</span>
        </template>
      </el-table-column>
      <el-table-column width="110" align="center" label="归档日期" sortable prop="entrustmentDate"
        column-key="entrustmentDate">
        <template slot-scope="scope">
          <span>{{ scope.row.archivingDate }}</span>
        </template>
      </el-table-column>
      <el-table-column width="140" align="center" label="创建时间" sortable prop="createTime" column-key="createTime">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }} </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="110">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.show == true && scope.row.username !== undefined" class="item"
            :content="scope.row.username" placement="top-start">
            <el-dropdown @command="handleCommand">
              <el-button type="primary">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
            </el-dropdown>
          </el-tooltip>
          <el-dropdown @command="handleCommand" v-else>
            <el-button type="danger">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-permission:function="['czCaseInfoManager_uploadCaseFile']"
                :command="showDialog(scope.$index, scope.row, 'upload')">上传卷宗材料</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_withDraw']" v-show="scope.row.caseStatus == '提交法院' ||
                scope.row.caseStatus == '调解中' ||
                scope.row.caseStatus == '缴费中' ||
                scope.row.caseStatus == '待开庭' ||
                scope.row.caseStatus == '待缴费' ||
                scope.row.caseStatus == '待开庭排期' ||
                scope.row.caseStatus == '调档中' ||
                scope.row.caseStatus == '判决中' ||
                scope.row.caseStatus == '判决生效中' ||
                scope.row.caseStatus == '待执行' ||
                scope.row.caseStatus == '执行中'
                " :command="showDialog(scope.$index, scope.row, 'withDraw')">申请撤诉</el-dropdown-item>

              <el-dropdown-item v-permission:function="['czCaseInfoManager_withDraw_confirm']"
                v-show="scope.row.caseStatus == '撤诉中'" :command="showDialog(scope.$index, scope.row, 'withDrawConfirm')
                  ">撤诉确认</el-dropdown-item>

              <el-dropdown-item v-permission:function="['czCaseInfoManager_backCase']" v-show="scope.row.caseStatus == '调解中' ||
                scope.row.caseStatus == '提交法院' ||
                scope.row.caseStatus == '撤诉中'
                " :command="showDialog(scope.$index, scope.row, 'backCase')">退案</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_backToStart']" v-show="scope.row.caseStatus == '待缴费' ||
                scope.row.caseStatus == '调解中'
                " :command="showDialog(scope.$index, scope.row, 'backToStart')">退回提交法院</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_switchRegister']" v-show="scope.row.caseStatus == '提交法院' ||
                scope.row.caseStatus == '调解中'
                " :command="showDialog(scope.$index, scope.row, 'switchRegister')">转立案</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_switchMediate']" v-show="scope.row.caseStatus == '提交法院' ||
                scope.row.caseStatus == '待缴费' ||
                scope.row.caseStatus == '缴费中' ||
                scope.row.caseStatus == '待开庭排期' ||
                scope.row.caseStatus == '调档中' ||
                scope.row.caseStatus == '待开庭' ||
                scope.row.caseStatus == '判决中' ||
                scope.row.caseStatus == '判决生效中'
                " :command="showDialog(scope.$index, scope.row, 'mediate')">转调解</el-dropdown-item>
              <el-dropdown-item v-show="scope.row.caseStatus == '待缴费'"
                v-permission:function="['czCaseInfoManager_deadlinePayDate']"
                :command="showDialog(scope.$index, scope.row, 'djf')">录入缴费日期</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_confirmPayment']"
                v-show="scope.row.caseStatus == '缴费中'"
                :command="showDialog(scope.$index, scope.row, 'pay')">确认缴费</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_setTrialDate']"
                v-show="scope.row.caseStatus == '待开庭排期'"
                :command="showDialog(scope.$index, scope.row, 'hearing')">设置开庭时间</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_confirmDiaoDang']"
                v-show="scope.row.caseStatus == '调档中'"
                :command="showDialog(scope.$index, scope.row, 'transfer')">完成调档</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_reScheduleg']"
                v-show="scope.row.caseStatus == '待开庭'"
                :command="showDialog(scope.$index, scope.row, 'scheduling')">重新排期</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_enterVerdict']"
                v-show="scope.row.caseStatus == '待开庭'"
                :command="showDialog(scope.$index, scope.row, 'affirmHearing')">确认开庭</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_entryExe']"
                v-show="scope.row.caseStatus == '待执行'"
                :command="showDialog(scope.$index, scope.row, 'editExe')">录入执行信息</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_fulfillmentDate']"
                v-show="scope.row.caseStatus == '判决中'"
                :command="showDialog(scope.$index, scope.row, 'hearingEnd')">录入判决生效日期</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_reScheduleg']"
                v-show="scope.row.caseStatus == '判决中'"
                :command="showDialog(scope.$index, scope.row, 'scheduling')">重新排期</el-dropdown-item>

              <el-dropdown-item v-permission:function="['czCaseInfoManager_noPerformance']"
                v-show="scope.row.caseStatus == '判决生效中'"
                :command="showDialog(scope.$index, scope.row, 'carry')">申请执行</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_edit']"
                v-show="isShowList[scope.$index] || isAdmin"
                :command="showDialog(scope.$index, scope.row, 'edit')">编辑</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_preview']"
                :command="showDialog(scope.$index, scope.row, 'preview')">预览</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_bl']" v-show="isShowList[scope.$index]"
                :command="showDialog(scope.$index, scope.row, 'addSingle')">被告补录
              </el-dropdown-item>
              <el-dropdown-item v-permission:function="['czCaseInfoManager_copy']" v-show="isShowList[scope.$index]"
                :command="showDialog(scope.$index, scope.row, 'copy')">复制案件</el-dropdown-item>

              <el-dropdown-item v-show="isShowList[scope.$index]"
                :command="showDialog(scope.$index, scope.row, 'delete')"
                v-permission:function="['czCaseInfoManager_delSingleCase']">删除</el-dropdown-item>

              <el-dropdown-item v-show="scope.row.caseStatus == '调解中'"
                v-permission:function="['czCaseInfoManager_setMediateDate']"
                :command="showDialog(scope.$index, scope.row, 'mediateEnd')">录入调解成功时间</el-dropdown-item>

              <el-dropdown-item v-permission:function="['czCaseInfoManager_lrMediate']"
                v-show="scope.row.caseStatus == '调解成功'"
                :command="showDialog(scope.$index, scope.row, 'entryscheme')">录入调解方案</el-dropdown-item>


              <el-dropdown-item v-permission:function="['czCaseInfoManager_editexe']"
                v-show="scope.row.caseStatus == '待执行'"
                :command="showDialog(scope.$index, scope.row, 'extryExe')">编辑执行计划</el-dropdown-item>

              <el-dropdown-item v-permission:function="['czCaseInfoManager_editMediate']"
                v-show="scope.row.caseStatus == '调解方案履行中'"
                :command="showDialog(scope.$index, scope.row, 'editMediate')">编辑调解方案</el-dropdown-item>

              <el-dropdown-item v-permission:function="['czCaseInfoManager_caseComplete']"
                v-show="scope.row.caseStatus == '调解方案履行中' || scope.row.caseStatus == '判决生效中' || scope.row.caseStatus == '执行中'"
                :command="showDialog(scope.$index, scope.row, 'agreementEnd')">结案</el-dropdown-item>

              <el-dropdown-item v-show="scope.row.caseStatus == '调解方案履行中'"
                v-permission:function="['czCaseInfoManager_breakMediate']"
                :command="showDialog(scope.$index, scope.row, 'carry')">申请执行</el-dropdown-item>

              <el-dropdown-item v-permission:function="['czCaseInfoManager_backCaseStatus']"
                :command="showDialog(scope.$index, scope.row, 'backCaseStatus')">管理员回退案件</el-dropdown-item>

              <el-dropdown-item v-show="scope.row.caseStatus == '已完成' || scope.row.caseStatus == '已撤诉' ||
                scope.row.caseStatus == '判决生效中' || scope.row.caseStatus == '调解方案履行中'"
                :command="showDialog(scope.$index, scope.row, 'caseArchiving')">案件归档</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="选择结案日期" :visible.sync="caseCompleDateVisible" width="30%">
      <span>
        <span style="margin-right: 10px;">结案日期：</span>
        <el-date-picker v-model="caseCompleDate" type="date" style="width: 10rem" placeholder="输入结案日期"
          value-format="yyyy-MM-dd" format="yyyyMMdd">
        </el-date-picker>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="caseCompleDateVisible = false">取 消</el-button>
        <el-button type="primary" @click="caseCompleDateReq()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 申请执行 -->
    <el-dialog id="exeElDialog" :title="isEdit == true ? '编辑执行信息' : '录入执行信息'" width="65%"
      :visible.sync="exeFormVisible1" :close-on-click-modal="false" center>
      <!-- v-if="showMediateField" -->
      <div style="
          width: 100%;
          margin: 0 auto;
          height: 10vh;
          display: flex;
          justify-content: center;
        ">
        <el-form :inline="true" :model="exeForm" ref="form" label-width="110px" style="width: 100%; margin: 0px auto">
          <div :style="{
            width: isMedEdit == false ? '600px' : '400px',
            margin: '0 auto',
          }">
            <el-form-item label="卡号" prop="cardNumber">
              <el-select v-model="exeForm.cardNumber" placeholder="" @change="exeChangeCard(exeForm.cardNumber)"
                style="width: 13vw">
                <el-option style="" :key="item.cardNumber" v-for="item in cardList" :label="item.cardNumber"
                  :value="item.cardNumber">
                </el-option>
              </el-select>
              <el-button type="primary" style="margin-left: 20px" v-if="isMedEdit == false" @click="addOneCardExe()">
                + 添加方案
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-collapse v-model="activeIndexs">
        <el-collapse-item :name="index" v-for="(item, index) in this.oneCardExeList" :key="index">
          <template slot="title">
            <div class="caseInfoItemHead">
              执行信息 {{ index + 1 + "(" + item.cardNumber + ")" }}
            </div>
          </template>
          <el-form ref="exeInfoForm" :rules="exeRule" :inline="true" :model="item" label-width="120px"
            style="width: 100%; margin: 0px auto; margin-top: 20px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="卡号" prop="cardNumber">
                  <el-input :disabled="true" v-model="item.cardNumber" placeholder=""></el-input>
                </el-form-item></el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="本金" prop="principal" style="margin-left: 7%">
                  <el-input @input="getNumber($event, exeForm, 'principal')" style="width: 10rem"
                    v-model="item.principal" placeholder="请输入本金" type="number"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="利息" style="margin-left: 7%">
                  <el-input @input="getNumber($event, exeForm, 'interest')" style="width: 10rem" v-model="item.interest"
                    placeholder="请输入利息" type="number"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="核销日期" prop="accountDestroyDate" style="margin-left: 7%">
                  <el-date-picker placeholder="选择时间" v-model="item.accountDestroyDate" style="width: 10rem"
                    value-format="yyyy-MM-dd" format="yyyyMMdd"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="核销截止日期" style="margin-left: 7%">
                  <el-date-picker placeholder="选择时间" v-model="item.accountDestroyEndDate" style="width: 10rem"
                    value-format="yyyy-MM-dd" format="yyyyMMdd"></el-date-picker>
                </el-form-item>
              </el-col>


            </el-row>
            <el-row>
              <el-col :span="12" style="height: 60px">
                <el-form-item label="核销利息：">
                  {{ item.hexiaoInterest == undefined ? 0 : towNumber(item.hexiaoInterest - item.interest) }}
                </el-form-item>
              </el-col>


              <el-col :span="12">
                <el-form-item label="利息截止日期" style="margin-left: 7%">
                  <el-date-picker placeholder="选择时间" v-model="item.interestDate" style="width: 10rem"
                    value-format="yyyy-MM-dd" format="yyyyMMdd"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>


            <el-row>
              <el-col :span="12">
                <el-form-item label="违约金" style="margin-left: 7%">
                  <el-input @input="getNumber($event, item, 'liquidatedDamages')" style="width: 10rem"
                    v-model="item.liquidatedDamages" placeholder="请输入违约金" type="number"></el-input>
                </el-form-item></el-col>
              <el-col :span="12">
                <el-form-item label="违约金截止日期" style="margin-left: 7%">
                  <el-date-picker placeholder="选择时间" v-model="item.liqDamagesEndDate" style="width: 10rem"
                    value-format="yyyy-MM-dd" format="yyyyMMdd"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="分期手续费" style="margin-left: 7%">
                  <el-input @input="getNumber($event, item, 'serviceCharge')" style="width: 10rem"
                    v-model="item.serviceCharge" placeholder="请输入分期手续费" type="number"></el-input>
                </el-form-item></el-col>
              <el-col :span="12">
                <el-form-item label="手续费截止日期" style="margin-left: 7%">
                  <el-date-picker placeholder="选择时间" v-model="item.serviceChargeEndDate" style="width: 10rem"
                    value-format="yyyy-MM-dd" format="yyyyMMdd"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="其他费用名称" style="margin-left: 7%">
                  <el-input style="width: 10rem" v-model="item.otherExpenseName" placeholder="请输入名称"></el-input>
                </el-form-item></el-col>
              <el-col :span="12">
                <el-form-item label="其他费用" style="margin-left: 7%">
                  <el-input style="width: 10rem" @input="getNumber($event, item, 'otherExpenses')"
                    v-model="item.otherExpenses" type="number" placeholder="请输入其他费用"></el-input>
                </el-form-item></el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="其他费用2名称" style="margin-left: 7%">
                  <el-input style="width: 10rem" v-model="item.otherExpense2Name" placeholder="请输入名称"></el-input>
                </el-form-item></el-col>
              <el-col :span="12">
                <el-form-item label="其他费用2" style="margin-left: 7%">
                  <el-input @input="getNumber($event, item, 'otherExpenses2')" style="width: 10rem"
                    v-model="item.otherExpenses2" type="number" placeholder="请输入其他费用2"></el-input>
                </el-form-item></el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="标的" style="margin-left: 7%">
                  <el-input style="width: 10rem" :disabled="true" v-model="item.underlyingAmount"
                    placeholder="请输入标的"></el-input> </el-form-item></el-col>

              <el-col :span="12">
                <el-form-item label="截止日期" prop="deadLineDate" style="margin-left: 7%">
                  <el-date-picker v-model="item.deadLineDate" type="date" style="width: 10rem" placeholder="请选择日期"
                    value-format="yyyy-MM-dd" format="yyyyMMdd">
                  </el-date-picker> </el-form-item></el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="依据文号" style="margin-left: 7%">
                  <el-input style="width: 10rem" v-model="item.referenceNumber" placeholder="请输入依据文号"></el-input>
                </el-form-item></el-col>

              <el-col :span="12">
                <el-form-item label="执行依据日期" prop="referenceDate" style="margin-left: 7%">
                  <el-date-picker v-model="item.referenceDate" type="date" style="width: 10rem" placeholder="请选择日期"
                    value-format="yyyy-MM-dd" format="yyyyMMdd">
                  </el-date-picker> </el-form-item></el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="公告费" style="margin-left: 7%" prop="announcementFee">
                  <el-input style="width: 10rem" v-model="item.announcementFee" placeholder="请输入公告费"></el-input>
                </el-form-item></el-col>

              <el-col :span="12">
                <el-form-item label="保全费" prop="propertyPreservationFee" style="margin-left: 7%">
                  <el-input style="width: 10rem" v-model="item.propertyPreservationFee" placeholder="请输入保全费"></el-input>
                </el-form-item></el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="已还金额" style="margin-left: 7%" prop="repaidAmount">
                  <el-input style="width: 10rem" v-model="item.repaidAmount" placeholder="已还金额"></el-input>
                </el-form-item></el-col>

              <el-col :span="12">
                <el-form-item label="受理费" style="margin-left: 7%">
                  <el-input style="width: 10rem" v-model="item.processingFee" placeholder="请输入案件受理费"
                    type="number"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="执行律师" style="margin-left: 7%" prop="executingLawyers">
                  <el-select @keyup.enter.native="search()" clearable multiple v-model="item.executingLawyers"
                    placeholder="请选择" style="width: 10rem;">
                    <el-option v-for="item in agent" :key="item.value" :label="item.label" :value="item.label">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="执行依据主文" style="margin-left: 7%" prop="operativePart">
                  <el-input type="textarea" :cols="85" :rows="10" v-model="item.operativePart"
                    placeholder="请输入执行依据主文"></el-input>
                </el-form-item></el-col>
            </el-row>


            <el-row>
              <div>
                <el-button v-if="item.id == '' || item.id == undefined" size="small" type="primary" :disabled="btFlag"
                  v-permission:function="['czCaseInfoManager_btn_addExecute']"
                  @click="addObj(item, index)">录入执行计划</el-button>
                <el-button v-else size="small" type="primary" :disabled="btFlag"
                  v-permission:function="['czCaseInfoManager_btn_putExecute']"
                  @click="putObj(item, index)">修改执行计划</el-button>
                <el-button v-if="index != null" size="small" type="danger" :disabled="btFlag"
                  @click="delExe(index, item)">删除</el-button>
              </div>
            </el-row>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div slot="footer" class="dialog-footer">
        <el-row>

          <span style="margin-right: 10px;">执行申请日期：</span><el-date-picker v-model="executionDate" type="date"
            style="width: 10rem" placeholder="输入执行申请日期" value-format="yyyy-MM-dd" format="yyyyMMdd">
          </el-date-picker>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-button v-if="isMedEdit == false" :disabled="btFlag" size="small" type="success"
            @click="submitExeCase()">提交案件</el-button>
        </el-row>

      </div>
    </el-dialog>

    <!-- 录入执行计划 -->
    <el-dialog id="exeForm" :title="isEdit == true ? '编辑执行信息' : '录入执行信息'" width="65%" :visible.sync="exeFormVisible"
      :close-on-click-modal="false" center>
      <div>
        <el-form :inline="true" :model="exeInfoData" ref="exeInfoDataForm" :rules="exeInfoDataRule" label-width="110px"
          style="width: 100%; margin: 0px auto">
          <!-- <el-form-item label="执行案号"  style="margin-left: 7%" prop="exeCode" >
            <el-input style="width: 10rem" v-model="exeForm.exeCode" placeholder="请输入执行案号"></el-input>
          </el-form-item> -->
          <el-row>
            <el-col :span="24">
              <el-form ref="exeInfoDataForm" :rules="exeInfoDataRule" :inline="true" :model="exeInfoData"
                label-width="120px" style="width: 100%; margin: 0px auto">
                <el-col :span="24">
                  <el-form-item label="执行案号" prop="year">
                    <el-select style="width: 7vw" v-model="exeInfoData.year" placeholder="">
                      <el-option label="2023" value="2023"></el-option>
                      <el-option label="2024" value="2024"></el-option>
                      <el-option label="2025" value="2025"></el-option>
                      <el-option label="2026" value="2026"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label-width="50px" label="粤" id="code" prop="code">
                    <el-select v-model="exeInfoData.code" placeholder="" style="width: 7vw">
                      <el-option label="0902" value="0902"></el-option>
                      <el-option label="0904" value="0904"></el-option>
                      <el-option label="0981" value="0981"></el-option>
                      <el-option label="0982" value="0982"></el-option>
                      <el-option label="0983" value="0983"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item id="ms" prop="status">
                    <el-select v-model="exeInfoData.status" placeholder="" style="width: 7vw">
                      <el-option label="执" value="执"></el-option>
                      <el-option label="执保" value="执保"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="" id="mt" prop="num">
                    <el-input style="width: 7vw" v-model="exeInfoData.num" placeholder="请输入案号"></el-input>
                  </el-form-item>
                  <span style="line-height: 40px">号</span>
                </el-col>
              </el-form>
            </el-col>
          </el-row>

          <el-form-item label="执行法官" style="margin-left: 7%" prop="exeUndertakeJudge">
            <el-input style="width: 10rem" v-model="exeInfoData.exeUndertakeJudge" placeholder="请输入法官"></el-input>
          </el-form-item>
          <el-form-item label="执行立案时间" style="margin-left: 7%" prop="exeFilingDate">
            <el-date-picker v-model="exeInfoData.exeFilingDate" type="date" value-format="yyyy-MM-dd" format="yyyyMMdd"
              style="width: 10rem" placeholder="请选择日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exeFormVisible = false" size="small">取 消</el-button>
        <el-button size="small" type="primary" :disabled="btFlag"
          v-permission:function="['czCaseInfoManager_btn_putExecute']" @click="editExeInfo()">修改执行案件信息</el-button>
      </div>
    </el-dialog>

    <!-- 录入调解方案 -->
    <el-dialog id="exeForm" :title="isMedEdit == true ? '编辑调解方案' : '录入调解方案'" width="60%" :visible.sync="schemeShow"
      :close-on-click-modal="false" center>
      <!-- v-if="showMediateField" -->
      <div style="
          width: 100%;
          margin: 0 auto;
          height: 10vh;
          display: flex;
          justify-content: center;
        ">
        <el-form ref="mediateForm" :rules="mediateRule" :inline="true" :model="mediateData" label-width="120px"
          style="width: 100%; margin: 0px auto">
          <!-- <el-col :span="20" :offset="2"> -->
          <!-- sss -->
          <div :style="{
            width: isMedEdit == false ? '600px' : '400px',
            margin: '0 auto',
          }">
            <el-form-item label="卡号" prop="cardNumber">
              <el-select v-model="mediateData.cardNumber" placeholder="" @change="changeCard(mediateData.cardNumber)"
                style="width: 13vw">
                <el-option style="" :key="item.cardNumber" v-for="item in cardList" :label="item.cardNumber"
                  :value="item.cardNumber">
                </el-option>
              </el-select>
              <el-button type="primary" style="margin-left: 20px" v-if="isMedEdit == false" @click="addOneCardMediate">
                + 添加方案
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-collapse v-model="activeIndexs">
        <el-collapse-item :name="index" v-for="(item, index) in oneCardMediateList" :key="index">
          <template slot="title">
            <div class="caseInfoItemHead">还款方案 {{ index + 1 }}</div>
          </template>
          <el-form ref="mediateForm" :rules="mediateRule" :inline="true" :model="item" label-width="120px"
            style="width: 100%; margin: 0px auto">
            <el-col :span="12">
              <el-form-item label="方案开始日期" prop="schemeStartDate">
                <el-date-picker @change="startDate(item.schemeStartDate, index)" v-model="item.schemeStartDate"
                  type="date" value-format="yyyy-MM-dd" style="width: 13vw" placeholder="请选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="方案结束日期" prop="schemeEndDate">
                <el-date-picker @change="endDate(item.schemeEndDate, index)" v-model="item.schemeEndDate" type="date"
                  value-format="yyyy-MM-dd" style="width: 13vw" placeholder="请选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="分期数" prop="installmentNum">
                <el-input style="width: 13vw" @input="getNumber($event, mediateData, 'installmentNum')"
                  v-model="item.installmentNum" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="每月还款金额" prop="monthlyAmount">
                <el-input style="width: 13vw" @input="getNumber($event, mediateData, 'monthlyAmount')"
                  v-model="item.monthlyAmount" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="首期还款额" prop="fristIssueAmount">
                <el-input @input="getNumber($event, mediateData, 'fristIssueAmount')" style="width: 13vw"
                  v-model="item.fristIssueAmount" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最后一期还款额" prop="lastIssueAmount">
                <el-input @input="getNumber($event, mediateData, 'lastIssueAmount')" style="width: 13vw"
                  v-model="item.lastIssueAmount" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="每月还款日" prop="mouthlyPayDate">
                <el-select @change="setHKday" style="width: 13vw" v-model="item.mouthlyPayDate" placeholder="请选择">
                  <el-option v-for="item in options" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="标的">
                <el-input style="width: 13vw" :disabled="true" v-model="item.underlyingAmount">
                </el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div style="margin: 20px auto" :style="{ width: isMedEdit == false ? '200px' : '100px' }">
            <el-button v-if="isMedEdit == true" size="small" :disabled="btFlag" type="primary"
              v-permission:function="['czCaseInfoManager_btn_putMediate']"
              @click="updateMediateMessage(item, index)">修改调解方案</el-button>
            <el-button v-else :disabled="btFlag" size="small" type="primary"
              v-permission:function="['czCaseInfoManager_btn_addMediate']"
              @click="addMediateMessage(item, index)">录入调解方案</el-button>
            <el-button type="danger" size="small" v-if="isMedEdit == false" @click="deleteOneCardMediate(index)">
              删除方案
            </el-button>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="isMedEdit == false" :disabled="btFlag" size="small" type="success"
          v-permission:function="['czCaseInfoManager_btn_submitCase']"
          @click="submitMediateCase(mediateData)">提交案件</el-button>
      </div>
      <!-- </el-form> -->
    </el-dialog>
    <!-- 录入判决生效时间 -->
    <el-dialog title="判决日期" :close-on-click-modal="false" :visible.sync="performShow" width="50%" center>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="performTimeForm" :model="performTimeModel" style="width: 100%" :rules="performTimeRule">
            <el-form-item label="判决生效日期:" prop="performDate">
              <el-date-picker v-model="performTimeModel.performDate" type="date" style="width: 100%"
                value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="请选择判决生效日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="performShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="fulfillmentDate()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 录入调解成功时间 -->
    <el-dialog title="调解成功时间" :visible.sync="mediateTimeShow" width="50%" :close-on-click-modal="false" center>
      <el-row>
        <el-col :span="24">
          <el-form ref="mediateForm" :rules="mediateRule" :inline="true" :model="mediateData" label-width="120px"
            style="width: 100%; margin: 0px auto">
            <el-col :span="24">
              <el-form-item label="调解案号" prop="year">
                <el-select style="width: 7vw" v-model="mediateData.year" placeholder="">
                  <el-option label="2023" value="2023"></el-option>
                  <el-option label="2024" value="2024"></el-option>
                  <el-option label="2025" value="2025"></el-option>
                  <el-option label="2026" value="2026"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label-width="50px" label="粤" id="code" prop="code">
                <el-select v-model="mediateData.code" placeholder="" style="width: 7vw">
                  <el-option label="0902" value="0902"></el-option>
                  <el-option label="0904" value="0904"></el-option>
                  <el-option label="0981" value="0981"></el-option>
                  <el-option label="0982" value="0982"></el-option>
                  <el-option label="0983" value="0983"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" id="ms" prop="status">
                <el-select v-model="mediateData.status" placeholder="" style="width: 7vw">
                  <el-option label="民初" value="民初"></el-option>
                  <el-option label="诉前调书" value="诉前调书"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" id="mt" prop="mediateCod">
                <el-input style="width: 7vw" v-model="mediateData.mediateCod" placeholder="请输入案号"></el-input>
              </el-form-item>
              <span style="line-height: 40px">号</span>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="mediateTimeform" :model="mediateTimeModel" label-width="120" style="width: 100%"
            :rules="mediateTimeRule">
            <el-form-item label="调解成功日期:" prop="mediateDate" label-width="120">
              <el-date-picker v-model="mediateTimeModel.mediateDate" type="date" style="width: 70%" placeholder="请选择日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="立案日期:" prop="filingDate" label-width="120">
              <el-date-picker v-model="mediateTimeModel.filingDate" type="date" style="width: 70%" placeholder="请选择日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="调解员:" prop="mediateId" label-width="120">
              <!-- v-model="" -->
              <el-select style="width: 70%" v-model="mediateTimeModel.mediateId" placeholder="请选择调解员">
                <el-option v-for="item in mediateNumberList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <!-- </div> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="mediateTimeShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="setMediateDate()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 调解撤诉 -->
    <el-dialog title="申请撤诉" :visible.sync="withDrawFormVisible" width="40%" :close-on-click-modal="false" center>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="withDrawForm" :model="withDrawModel" label-width="120" :rules="withDrawRules">
            <el-form-item label="撤诉申请时间:" prop="date">
              <el-date-picker v-model="withDrawModel.date" type="date" style="width: 12rem" placeholder="请选择撤诉申请日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="撤诉原因:" prop="reason">
              <el-select style="width: 12rem" v-model="withDrawModel.reason" placeholder="请选择撤诉原因">
                <el-option v-for="item in chesuType" :label="item.lable" :value="item.value" :key="item.lable">
                </el-option>
              </el-select>
              <!-- <el-input type="textarea" autosize v-model="withDrawModel.reason" style="width: 12rem"
                placeholder="请输入原因">
              </el-input> -->
            </el-form-item>
            <el-form-item label="调解员:" prop="mediateId" label-width="120">
              <!-- v-model="" -->
              <el-select style="width: 12rem" v-model="withDrawModel.mediateId" placeholder="请选择调解员">
                <el-option v-for="item in mediateNumberList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="withDrawFormVisible = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" v-permission:function="['czCaseInfoManager_withDrawForm']"
          @click="withDraw()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 法院退案 -->
    <el-dialog title="法院退案" :visible.sync="backCaseFormVisible" width="40%" :close-on-click-modal="false" center>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="backCaseForm" :model="backCaseModel" label-width="120" :rules="backCaseRules">
            <el-form-item label="退案时间:" prop="date">
              <el-date-picker v-model="backCaseModel.date" type="date" style="width: 12rem" placeholder="请选择撤诉日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="退案原因:" prop="reason">
              <el-input type="textarea" autosize v-model="backCaseModel.reason" style="width: 12rem"
                placeholder="请输入原因">
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="withDrawFormVisible = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" v-permission:function="['czCaseInfoManager_backCaseForm']"
          @click="backCase()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量退案 -->
    <el-dialog title="批量退案" :visible.sync="batchBackCaseFormVisible" width="40%" :close-on-click-modal="false" center>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="backCaseForm" :model="backCaseModel" label-width="120" :rules="backCaseRules">
            <el-form-item label="退案时间:" prop="date">
              <el-date-picker v-model="backCaseModel.date" type="date" style="width: 12rem" placeholder="请选择撤诉日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="退案原因:" prop="reason">
              <el-input type="textarea" autosize v-model="backCaseModel.reason" style="width: 12rem"
                placeholder="请输入原因">
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="batchBackCaseFormVisible = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" v-permission:function="['czCaseInfoManager_backCaseForm']"
          @click="backCase()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 开庭时间 -->
    <el-dialog title="开庭时间" :visible.sync="hearingShow" width="40%" :close-on-click-modal="false" center>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="hearingTimeform" :model="hearingTimeModel" label-width="120" :rules="hearingTimeRule">
            <el-form-item label="开庭时间:" prop="hearingDate">
              <el-date-picker v-model="hearingTimeModel.hearingDate" type="datetime" style="width: 12rem"
                placeholder="请选择开庭日期" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="审判法官:" prop="judge">
              <el-input v-model="hearingTimeModel.judge" style="width: 12rem" placeholder="请输入审判法官">
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="hearingShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="hearing()">确 定</el-button>
      </span>
    </el-dialog>

    <!--撤诉确认-->
    <el-dialog title="撤诉确认" :visible.sync="dropLawsuitRulingShow" width="40%" :close-on-click-modal="false" center>
      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="hearingTimeform" :model="dropLawsuitRulingModel" label-width="120" :rules="withDrawRulingRules">
            <el-form-item label="撤诉裁定日期:" prop="dropLawsuitRulingDate">
              <el-date-picker v-model="dropLawsuitRulingModel.dropLawsuitRulingDate" type="date" style="width: 16rem"
                placeholder="请选择开庭日期" value-format="yyyy-MM-dd" format="yyyyMMdd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="案号:" prop="registerCode">
              <el-input v-model="dropLawsuitRulingModel.registerCode" style="width: 16rem" placeholder="请输入案号">
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dropLawsuitRulingShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="dropLawsuitRulingConfirm()"
          v-permission:function="['czCaseInfoManager_dropLawsuitRulingConfirm']">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 结算时间 -->
    <el-dialog title="结算时间" :visible.sync="settleDateShow" width="40%" :close-on-click-modal="false" center>
      <el-row style="width: 100%; margin-top: 1rem" id="lxsj">
        <el-col :span="24">
          <el-form ref="proccessDateform" :model="proccessDateModel" label-width="120" :rules="proccessDateRule">
            <el-form-item label="结算阶段:" prop="processValue">
              <el-select v-model="proccessDateModel.processValue" placeholder="请选择">
                <el-option v-for="item in proccessOption" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算日期:" prop="settleDate">
              <el-date-picker v-model="proccessDateModel.settleDate" type="date" style="width: 12rem"
                placeholder="请选择结算日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="settleDateShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="setSettleDate()">确 定</el-button>
      </span>
    </el-dialog>

    <!--导入结算表-->
    <el-dialog title="结算时间" :visible.sync="settleDateShow" width="40%" :close-on-click-modal="false" center>
      <el-row style="width: 100%; margin-top: 1rem" id="lxsj">
        <el-col :span="24">
          <el-form ref="proccessDateform" :model="proccessDateModel" label-width="120" :rules="proccessDateRule">
            <el-form-item label="结算阶段:" prop="processValue">
              <el-select v-model="proccessDateModel.processValue" placeholder="请选择">
                <el-option v-for="item in proccessOption" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算日期:" prop="settleDate">
              <el-date-picker v-model="proccessDateModel.settleDate" type="date" style="width: 12rem"
                placeholder="请选择结算日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="settleDateShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="setSettleDate()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 提交立案 -->
    <el-dialog :close-on-click-modal="false" title="提交立案" :visible.sync="registerBoxShow" width="40%" center>
      <el-row style="width: 100%">
        <el-col :span="6" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form ref="year" :model="registerModel" label-width="120" :rules="registerRule">
            <el-form-item label="案号:" prop="year">
              <el-select v-model="registerModel.year" placeholder="" style="width: 60%">
                <el-option label="2023" value="2023"></el-option>
                <el-option label="2024" value="2024"></el-option>
                <el-option label="2025" value="2025"></el-option>
                <el-option label="2026" value="2026"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="5" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 7 }">
          <el-form ref="code" label-width="120" :model="registerModel" style="width: 100%" :rules="registerRule">
            <el-form-item label="粤" prop="code">
              <el-select v-model="registerModel.code" placeholder="" style="width: 70%">
                <el-option label="0902" value="0902"></el-option>
                <el-option label="0904" value="0904"></el-option>
                <el-option label="0981" value="0981"></el-option>
                <el-option label="0982" value="0982"></el-option>
                <el-option label="0983" value="0983"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="6" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form ref="registerCode" label-width="120" :model="registerModel" style="width: 100%"
            :rules="registerRule">
            <el-form-item label="民初" prop="registerCode">
              <el-input style="width: 60%" placeholder="" v-model="registerModel.registerCode"
                class="input-with-select">
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="1" style="line-height: 40px"> 号 </el-col>
      </el-row>

      <el-row style="width: 100%" id="lxsj">
        <el-col :span="24">
          <el-form ref="paymentDate" :model="caseData" label-width="120" :inline="true" style="width: 100%"
            :rules="registerRule">
            <el-form-item label="缴费截止日期:" prop="paymentDate">
              <el-date-picker style="width: 80%" v-model="caseData.paymentDate" type="date" value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="案件立案日期:" prop="filingDate">
              <el-date-picker style="width: 80%" v-model="caseData.filingDate" type="date" value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span style="width: 10rem" slot="footer" class="dialog-footer">
        <el-button @click="registerBoxShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="deadlinePayDate()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑案件 -->
    <div class="editCase">
      <el-dialog title="编辑案件" :visible.sync="testVis" width="100%" custom-class="heightFull" center @close="closeDia"
        :close-on-click-modal="false">
        <Register @getCaseStatus="getCaseStatus" :id="id" :plaintiffName="plaintiffName" :currentRow="currentRow"
          :index="listIndex" :list="currentList" :page="CaseInfo.page" :mkey="CaseInfo.keyWord" :limit="CaseInfo.limit"
          v-if="testVis"></Register>
      </el-dialog>
    </div>
    <!-- 预览案件 -->
    <div>
      <el-dialog class="previewDialog" custom-class="heightFull" :title="'预览案件'" :visible.sync="isPreview" width="70%"
        center :close-on-click-modal="false">
        <Preview :caseId="this.id" ref="preview" v-if="isPreview"></Preview>
      </el-dialog>
    </div>

    <!-- 分页 -->
    <template slot="footer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="CaseInfo.page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000]"
        :page-size="CaseInfo.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </template>

    <!-- 批量修改案件状态 -->
    <el-dialog title="批量修改案件状态" :visible.sync="setStatusdialogVisible" width="50%" class="outDialog"
      :close-on-click-modal="false">
      <el-form ref="plCaseForm" :model="plStatus" :rules="batchStatusRule" label-width="170px">
        <el-form-item label="案件状态:" prop="caseSt" id="caseSt">
          <!-- <span></span> -->
          <el-select style="width: 70%; margin-bottom: 20px" v-permission:function="['czCaseInfoManager_cz_caseStatus']"
            v-model="plStatus.caseSt" placeholder="请选择" @change="changeVal">
            <el-option v-for="item in plCaseStatus" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select style="width: 70%" v-permission:function="['czCaseInfoManager_yyjl_caseStatus']"
            v-model="plStatus.caseSt" placeholder="请选择" @change="changeVal">
            <el-option v-for="item in plLian" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="caseDate != ''" :label="caseDate" prop="date" id="caseSt">
          <el-date-picker value-format="yyyy-MM-dd" style="width: 70%" v-model="plStatus.date" type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer" style="width: 160px; margin: 0 auto">
        <el-button @click="setStatusdialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setCaseStatus()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量设置代理人 -->
    <el-dialog title="选择代理人" :visible.sync="setAgentdialogVisible" width="30%" class="outDialog"
      :close-on-click-modal="false">
      <span>选择代理人</span>
      <el-select multiple v-model="setAgentId" placeholder="请选择" style="margin-left: 20px">
        <el-option v-for="item in agent" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setAgentdialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setAgent">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 生成文书 -->
    <el-dialog title="生成文书" :visible.sync="documentDialogVisible" width="40%" center :close-on-click-modal="false">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0"></div>
      <el-checkbox-group v-model="checkedDocument" @change="handleCheckedDocumentChange">
        <el-checkbox v-for="document in documentType" :label="document" :key="document">{{ document }}</el-checkbox>
      </el-checkbox-group>

      <div style="margin-top: 50px">
        <el-row style="width: 100%">
          <label style="text-align: right; line-height: 30px">落款日期（默认为当天）：</label>
          <el-date-picker v-model="dropOffDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
            placeholder="选择落款日期">
          </el-date-picker>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="documentDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="downloadDucument">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 生成高州文书 -->
    <el-dialog title="生成高州文书" :visible.sync="documentDialogVisibleByGaoZhou" width="40%" center
      :close-on-click-modal="false">
      <div>
        <el-row style="width: 100%">
          <label style="text-align: right; line-height: 30px">落款日期（默认为当天）：</label>
          <el-date-picker v-model="dropOffDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
            placeholder="选择落款日期">
          </el-date-picker>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="documentDialogVisibleByGaoZhou = false">取 消</el-button>
        <el-button type="primary" @click="createGaoZhouDoc">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上传卷宗材料 -->
    <el-dialog title="上传卷宗材料" :visible.sync="caseUploadShow" width="50%" center :close-on-click-modal="false">
      <div style="width: 100%; margin: 0px auto">
        <el-form>
          <single-upload v-if="caseUploadShow" ref="singleUpload" v-model="fileUrl" @test="addUploadRecord"
            :caseId="this.id" />
        </el-form>
      </div>

    </el-dialog>
    <!-- 批量备注 -->
    <el-dialog title="批量备注" :visible.sync="showNotes" width="30%" center :close-on-click-modal="false">
      <el-input type="textarea" :rows="12" placeholder="请输入内容" v-model="notesText">
      </el-input>
      <div style="display: flex" class="notesBtn">
        <div>
          <el-button style="" type="primary" @click="addNotes">确定</el-button>
        </div>
        <div>
          <el-button style="margin-left: 10px" type="" @click="closeNotes">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增案件 -->
    <el-dialog title="创建案件" :visible.sync="centerDialogVisible" width="30%" center :close-on-click-modal="false">
      <el-form :model="CaseForm" :rules="rules" ref="CaseForm" label-width="100px" class="demo-CaseForm">
        <el-form-item label="原告" prop="bankId">
          <el-select style="width: 85%" clearable v-model="CaseForm.bankId" placeholder="请选择">
            <el-option v-for="item in plaintiffName" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="案由" prop="cause">
          <el-select v-model="CaseForm.cause" placeholder="请选择">
            <el-option v-for="item in causeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="案件类型" prop="caseType">
          <el-select v-model="CaseForm.caseType" placeholder="请选择">
            <el-option label="全流程" value="全流程"></el-option>
            <el-option label="仅执行" value="仅执行"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="身份证图片">
          <el-upload style="width: 85%" ref="upload" class="upload-demo" :on-change="fileChange"
            :action="getUploadUrl()" :http-request="HttpUploadFile" multiple :auto-upload="false" :file-list="fileList"
            :limit="100">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>

        <el-form-item prop="entrustmentDate" label="委托日期">
          <el-date-picker style="width: 85%" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
            placeholder="选择日期" v-model="CaseForm.entrustmentDate"></el-date-picker>
        </el-form-item>

        <el-form-item label="案件批次" prop="batchId">
          <el-input v-model="CaseForm.batchId" style="width: 85%"></el-input>
        </el-form-item>

        <el-form-item v-if="CaseForm.caseType == '仅执行'" label="卡号" prop="cardNumber">
          <el-input v-model="CaseForm.cardNumber" style="width: 85%"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('CaseForm')">立即创建</el-button>
          <el-button @click="resetForm('CaseForm')">重置</el-button>
          <el-button @click="centerDialogVisible = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 回退案件 -->
    <el-dialog :visible.sync="backCaseStatusVisible" title="案件回退" width="30%">
      <el-form ref="backStatusInfoForm" :model="backStatusInfo" :rules="backStatusRule" size="medium">
        <el-form-item label="回退状态" prop="status">
          <el-select v-model="backStatusInfo.status" placeholder="请选择回退状态" style="width: 80%" clearable>
            <el-option label="调解中" value="调解中"></el-option>
            <el-option label="待开庭排期" value="待开庭排期"></el-option>
            <el-option label="调解方案履行中" value="调解方案履行中"></el-option>
            <el-option label="判决生效中" value="判决生效中"></el-option>
            <el-option label="待执行" value="待执行"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回退人:" prop="name" label-width="100">
          <el-input v-model="backStatusInfo.name" placeholder="输入回退人" clearable style="width: 85%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="backCaseStatusVisible = false">取消</el-button>
        <el-button type="primary" @click="backCaseStatus">确定</el-button>
      </div>
    </el-dialog>

    <!-- 录入归档日期 -->
    <el-dialog title="归档" :close-on-click-modal="false" :visible.sync="caseEndModelShow" width="30%" center>
      <el-row style="width: 100%">
        <el-col :span="24">
          <el-form ref="archivingDateForm" :model="caseEndModel" style="width: 100%" :rules="archivingDateRule">
            <el-form-item label="归档状态" prop="archivingStatus">
              <el-select v-model="caseEndModel.archivingStatus" placeholder="请选择归档状态" style="width: 100%" clearable>
                <el-option label="调解方案履行阶段" value="调解方案履行阶段"></el-option>
                <el-option label="判决生效阶段" value="判决生效阶段"></el-option>
                <el-option label="归档完成" value="归档完成"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="归档日期:" prop="archivingDate">
              <el-date-picker v-model="caseEndModel.archivingDate" type="date" style="width: 100%"
                value-format="yyyy-MM-dd" format="yyyyMMdd" placeholder="请选择归档日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="caseEndModelShow = false">取 消</el-button>
        <el-button :disabled="btFlag" type="primary" @click="setCaseArchivingDate">确 定</el-button>
      </span>
    </el-dialog>

  </d2-container>
</template>
<style scoped>
@import "../../../assets/style/CaseInfo/caseInfo.css";
</style>
<script>
let ws = undefined;
import Vue from "vue";
import { downLoadFile, downLoadExcel } from "@/plugin/axios";
import store from "@/store";
import Register from "@/pages/caseMediate/register";
import Preview from "@/pages/caseMediate/preview";
import {
  addCaseRemark,
  page,
  addCaseInfo,
  selectBank,
  selectAgent,
  selectCause,
  addSingleDefendant,
  setAgent,
  deletetCase,
  batchDeletetCase,
  setCaseStatus,
  copyCaseById,
  expBankExcel,
  expBankLedgerByJieSuan,
  switchRegister,
  deadlinePayDate,
  confirmPayment,
  setTrialDate,
  performance,
  setArchivingDate,
  noPerformance,
  confirmDiaoDang,
  fulfillmentDate,
  enterVerdict,
  reScheduleg,
  caseMediate,
  setMediateDate,
  addMediateMessage,
  getMediateMessage,
  updateMediateMessage,
  backToStart,
  upLoadCaseFile,
  withDraw,
  backCase,
  uploadTable,
  uploadSingleFile,
  batchRegister,
  submitMediateCase,
  deleteMediateData,
  batchBackCase,
  settleDate,
  confirmDropLawsuit,
  calculationCardAmount,
  previewUrl,
  getCaseUploadFile,
  directUpload,
  backCaseStatusApi
} from "@/api/czManager/czCaseInfo/index";
import singleUpload from "@/pages/components/upload"
import { getCastAllInfo } from "@/api/czManager/register/index";
import {
  getExecutePlan,
  addObj,
  putObj,
  delExe,
  submitExeCase,
  submitExeInfo,
} from "@/api/czManager/executePlan/index";
import { mapGetters } from "vuex";
import { getUserId } from "@/api/sys/user.js";
import util from "@/libs/util";
import { MonthsBetw } from "@/utils/myUtils/validate.js";
var validateCard = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("信用卡不能为空"));
  } else if (value.length < 16 || value.length > 16) {
    callback("信用卡位数不对");
  } else {
    callback();
  }
};
export default {
  name: "userManager",
  components: {
    Register,
    Preview,
    singleUpload
  },
  data() {
    var checkDate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("日期不能为空"));
      }
    };
    const validateContent = (rule, value, callback) => {
      if (!value.includes('本金')) {
        callback(new Error('内容必须包含字符串 "本金"'));
      } else {
        callback();
      }
    };
    return {
      batchBackCaseFormVisible: false,
      activeIndexs: [],
      mediateNumberList: [],
      currentMediateIndex: "",
      currentCardNumber: "",
      oneCardMediateList: [],
      oneCardExeList: [],
      isYearMoneyFlag: false,
      batchNumber: "",
      batchDialog: false,
      mediateList: [],
      cardList: [],
      showMediateField: false,
      isBatchRegister: false,
      climit: 10,
      ckey: "",
      notesText: "",
      showNotes: false,
      listIndex: 0,
      currentList: [],
      tableHeight: "510",
      tableWidth: "",
      currentRow: {},
      activeName: "",
      collClick: "",
      dis: false,
      value1: "",
      value2: "",
      value3: "",
      isAdmin: "",
      options: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      backCaseModel: { date: "", reason: "" },
      withDrawModel: { date: "", reason: "", mediateId: "" },
      plStatus: { caseSt: "", date: "" },
      caseDate: "",
      caseStatusDate: "",
      chesuType: [
        { label: "立案撤诉", value: "裁定撤诉-被告死亡，法院驳回起诉" },
        { label: "立案撤诉", value: "裁定撤诉-被告已还清" },
        { label: "立案撤诉", value: "裁定撤诉-律师或者客户要求撤诉" },
        { label: "立案撤诉", value: "裁定撤诉-不缴费撤诉" },
      ],
      plCaseStatus: [
        { label: "异常", value: "异常" },
        { label: "处置中", value: "处置中" },
        { label: "提交诉讼服务网", value: "提交诉讼服务网" },
        { label: "提交法院", value: "提交法院" },
      ],
      causeList: [],
      proccessOption: [
        { value: "立案结算", label: "立案结算" },
        { value: "调解/判决结算", label: "调解/判决结算" },
        { value: "申请执行结算", label: "申请执行结算" },
        { value: "执行完毕结算", label: "执行完毕结算" },
      ],

      proccessDateModel: { settleDate: "", processValue: "" },
      settleDateShow: false,
      plLian: [
        {
          label: "调解中",
          value: "调解中",
        },
      ],
      backCaseFormVisible: false,
      withDrawFormVisible: false,
      btFlag: false,
      exeFormVisible1: false,
      previewData: [],
      registerModel: { year: "2024", code: "", registerCode: "" },
      isMediate: [],
      caseUploadShow: false,
      cMediateData: undefined,
      cExePlan: undefined,
      isMedEdit: false,
      mediateData: {
        status: "",
        code: "",
        year: "2024",
        mediateCod: "",
        mediateCode: "",
        caseId: "",
        fristIssueAmount: "",
        id: "",
        installmentNum: "",
        lastIssueAmount: "",
        mediateCode: "",
        monthlyAmount: "",
        mouthlyPayDate: "",
        repaymentNum: "",
        schemeEndDate: "",
        schemeStartDate: "",
        underlyingAmount: "",
        cardNumber: "",
      },
      mediateTimeShow: false,
      code: "",
      withDrawRulingRules: {
        registerCode: [
          { required: true, message: "请输入案号", trigger: "blur" },
        ],
        dropLawsuitRulingDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
      },
      withDrawRules: {
        date: [{ required: true, message: "请选择日期", trigger: "change" }],
        reason: [{ required: true, message: "请输入原因", trigger: "blur" }],
        mediateId: [
          { required: true, message: "请选择调解员", trigger: "change" },
        ],
      },
      backCaseRules: {
        date: [{ required: true, message: "请选择日期", trigger: "change" }],
        reason: [{ required: true, message: "请输入原因", trigger: "blur" }],
      },
      batchStatusRule: {
        caseSt: [
          { required: true, message: "请选择案件状态", trigger: "change" },
        ],
        date: [{ required: true, message: "请选择日期", trigger: "change" }],
      },
      proccessDateRule: {
        settleDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        processValue: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
      },
      mediateRule: {
        cardNumber: [
          {
            required: true,
            message: "请选择卡号",
            trigger: "change",
          },
        ],

        status: [{ required: true, message: "请选择", trigger: "change" }],
        year: [{ required: true, message: "请选择日期", trigger: "change" }],
        code: [{ required: true, message: "请选择编号", trigger: "change" }],
        mediateCode: [
          { required: true, message: "请输入案号", trigger: "blur" },
        ],

        mediateCod: [
          { required: true, message: "请输入案号", trigger: "blur" },
        ],
        schemeStartDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        schemeEndDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        monthlyAmount: [
          { required: true, message: "请输入金额", trigger: "blur" },
        ],
        fristIssueAmount: [
          { required: true, message: "请输入金额", trigger: "blur" },
        ],
        lastIssueAmount: [
          { required: true, message: "请输入金额", trigger: "blur" },
        ],
        mouthlyPayDate: [
          { required: true, message: "请输入哪一天", trigger: "blur" },
        ],
        underlyingAmount: [
          { required: true, message: "请输入金额", trigger: "blur" },
        ],
        installmentNum: [
          { required: true, message: "请输入分期数", trigger: "blur" },
        ],
      },
      exeRule: {
        principal: [
          {
            required: true,
            message: "请输入本金",
            trigger: "blur",
          },
        ],
        deadLineDate: [
          {
            required: true,
            message: "请输入截止日期",
            trigger: "blur",
          },
        ],
        referenceNumber: [
          {
            required: true,
            message: "请输入依据文号",
            trigger: "blur",
          },
        ],
        operativePart: [
          {
            required: true,
            message: "请输入执行依据主文,并且包含“本金”字样",
            trigger: "blur",
            validator: validateContent
          },
        ],
        referenceDate: [
          {
            required: true,
            message: "请输入执行依据日期",
            trigger: "blur",
          },
        ],
        executingLawyers: [
          {
            required: true,
            message: "请选择执行律师",
            trigger: "blur",
          },
        ]
      },
      exeCardFormRule: {
        cardNumber: [
          { required: true, message: "请选择卡号", trigger: "blur" },
        ],
      },
      exeInfoData: {
        year: "",
        code: "",
        status: "",
        num: "",
        caseId: "",
        exeCode: "",
        exeFilingDate: "",
        exeUndertakeJudge: "",
      },
      exeInfoDataRule: {
        status: [{ required: true, message: "请选择", trigger: "change" }],
        year: [{ required: true, message: "请选择日期", trigger: "change" }],
        code: [{ required: true, message: "请选择编号", trigger: "change" }],
        num: [{ required: true, message: "请选择案号", trigger: "change" }],
        exeFilingDate: [
          { required: true, message: "请选择立案日期", trigger: "change" },
        ],
        exeUndertakeJudge: [
          { required: true, message: "输入法官", trigger: "change" },
        ],
      },
      edit: [],
      isEdit: false,
      exeForm: {
        cardNumber: "",
      },
      exeFormVisible: false,
      mediateShow: false,
      mediateTimeModel: { mediateDate: "", mediateId: "", filingDate: "" },
      performTimeModel: { performDate: "" },
      caseEndModel: { caseId: "", archivingDate: "" },
      mediateDate: "",
      year: "2024",
      caseData: {
        caseIdList: [],
        caseId: "",
        paymentDate: "",
        registerCode: "",
        filingDate: "",
      },
      ttt: false,
      schemeShow: false,
      executeShow: false,
      performShow: false,
      performDate: "",
      caseCode: "",
      hearingEnd: "",
      hearingEndDate: "",
      hearingDate: "",
      hearingTimeModel: { hearingDate: "", judge: "" },
      hearingShow: false,
      dropLawsuitRulingModel: {
        caseId: "",
        dropLawsuitRulingDate: "",
        registerCode: "",
      },
      dropLawsuitRulingShow: false,
      caseEndModelShow: false,
      registerDate: "",
      registerShow: false,
      registerBoxShow: false,
      isShowList: [],
      headrt: 240,
      t: true,
      statusItems: [],
      val: "",
      show3: true,
      fullscreenLoading: true,
      test1: 1111,
      addSingleDefendantDialog: false,
      addCaseFileShow: false,
      caseFile: [],
      tOrder: 0,
      testVis: false,
      CaseInfo: {
        registerCode: "",
        batchId: "",
        cause: "",
        defendantName: "",
        plaintiffName: "",
        founder: "",
        caseStatus: [],
        underlyingAmount: "",
        courtName: "",
        agent: "",
        cardNum: "",
        sort: "",
        trialDate: "",
        caseIdList: [],
        courtSubDate: '',
        exeFilingDate: '',
        page: 1,
        limit: 50,
      },
      tempShow: false,
      fileData: new FormData(),
      fileList: [],
      caseFileList: [],
      caseFileData: new FormData(),
      plaintiffName: [],
      courtName: [],
      agent: [],
      Case: {
        caseCode: "",
        founder: "",
        batchId: "",
        plaintiffName: "",
        defendantName: "",
        underlyingAmount: "",
        entrustmentDate: "",
        caseStatus: "",
        courtName: "",
        agent: "",
        cardNum: "",
        page: 1,
        limit: 50,
      },
      caseSt: "",
      statusList: [],
      caseStatus: [],
      editCase: [],
      CaseForm: {
        batchId: "",
        bankId: "",
        fields: "",
        entrustmentDate: "",
        cause: "",
      },
      centerDialogVisible: false,
      form: {
        username: undefined,
        name: undefined,
        sex: "男",
        password: undefined,
        description: undefined,
      },
      mediateTimeRule: {
        mediateDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        mediateId: [
          {
            required: true,
            message: "请选择调解员",
            trigger: "change",
          },
        ],
        filingDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
      },
      performTimeRule: {
        performDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
      },
      archivingDateRule: {
        archivingStatus: [
          { required: true, message: "请选择归档状态", trigger: "blur" },
        ],
        archivingDate: [
          { required: true, message: "请选择归档日期", trigger: "change" },
        ],
      },
      hearingTimeRule: {
        judge: [{ required: true, message: "请输入法官", trigger: "blur" }],
        hearingDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
      },
      registerRule: {
        filingDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        paymentDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        year: [{ required: true, message: "请选择年份", trigger: "change" }],
        code: [{ required: true, message: "请选择编号", trigger: "change" }],
        registerCode: [
          { required: true, message: "请输入案号", trigger: "blur" },
        ],
      },
      rules: {
        batchId: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        cause: [{ required: true, message: "请选择案由", trigger: "blur" }],
        bankId: [{ required: true, message: "原告", trigger: "blur" }],
        entrustmentDate: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        caseType: [{ required: true, message: "请选择案件类型", trigger: "blur" }],
        cardNumber: [{ required: true, message: "原告", trigger: "blur" }]
      },
      loading: false,
      list: null,
      total: null,
      listLoading: true,
      listQuery: { page: 1, limit: 20, batchId: undefined },
      timeOrder: [
        { value: 0, label: "升序" },
        { value: 1, label: "降序" },
      ],
      isPreview: false,
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: { update: "编辑", create: "创建" },
      productName: [],
      mediateDat: "",
      tempShow: [],
      value: "",
      userId: "",
      tableKey: 0,
      fileName: "",
      id: "",
      validFile: false,
      //列表多选框数组
      caseIdList: [],
      //设置代理人对话框
      setAgentdialogVisible: false,
      setAgentId: [],
      setStatusdialogVisible: false,
      //生成文书对话框
      documentDialogVisible: false,
      documentDialogVisibleByGaoZhou: false,
      checkAll: true,
      //选择的文书
      checkedDocument: [
        "2025起诉状",
        "要素表",
        "所函",
        "授权委托书",
        "证据材料清单",
        "核销表格",
      ],
      documentType: [
        "起诉状",
        "2025起诉状",
        "要素表",
        "所函",
        "授权委托书",
        "证据材料清单",
        "核销表格",
        "财产保全申请书",
        "网络查控申请书",
        "担保函",
        "执行申请书",
        "通用民初模版",
        "民诉前调合订模版",
        "归档材料封面",
        "归档材料交接表"
      ],
      //文书生成落款日期
      dropOffDate: "",
      wst: {},
      isIndeterminate: true,
      // checkAll: true,
      linkSuccess: false,
      notify: [],
      mediateMoney: "",
      caseFileShow: false,
      exeMoney: "",
      mediateMoney: "",
      caseId: "",
      uploadType: "",
      caseFilesList: [],
      uploadExcelFileVisible: false,
      uploadExcelBank: '',
      executionDate: "",
      announcementFee: "",
      propertyPreservationFee: "",
      caseFilingFee: "",
      referenceNumber: "",
      operativePart: "",
      caseCompleDateVisible: false,
      caseCompleDate: '',
      idCardPageNum: 1,
      uploadStyle: 'display: none;',
      fileUrl: '',
      selectedCaseInfo: undefined,
      backCaseStatusVisible: false,
      backStatusInfo: {
        caseId: '',
        status: '',
        name: ''
      },
      backStatusRule: {
        name: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        status: [{ required: true, message: "请选择案由", trigger: "blur" }],
      }

    };
  },
  created() {
    let h = localStorage.getItem("tableHeight");
    if (h != undefined && h != "" && h != null) {
      this.tableHeight = h;
    }

    let username = this.$store.state.d2admin.permission.userName;
    if (username == "蓬莱管理员" || username == "曾靖雅") {
      this.isAdmin = true;
    }

    this.getList();
    getUserId()
      .then((res) => {
        this.userId = res.id;
        this.initWebsocket();
        let timeout = setInterval(() => {
          this.wst.send("-2");
          this.headrt--;
          if (this.headrt == 0) {
            this.wst.close();
            clearInterval(timeout);
          }
        }, 59000);
      })
      .catch((error) => { });
    store.dispatch("d2admin/data/getSelectList").then((res) => {
      this.courtName = store.state.d2admin.data.courtList;
      this.caseStatus = store.state.d2admin.data.caseStatus;
      this.productName = store.state.d2admin.data.productName;
      this.mediateNumberList = store.state.d2admin.data.mediateNumberList;
    });

    selectBank().then((response) => {
      this.plaintiffName = response;
    });
    selectAgent().then((response) => {
      this.agent = response;
    });
    selectCause().then((response) => {
      this.causeList = response;
    });
  },
  computed: {
    ...mapGetters(["elements"]),
    totalMoney: {
      get() {
        return (
          (this.installmentNum - this.repaymentNum) * this.monthlyAmount +
          this.fristIssueAmount +
          this.lastIssueAmount
        );
      },
    },
    totalUnderlyingAmount: {
      get() {
        if (this.mediateMoney != "") {
          return this.mediateMoney;
        }

        this.oneCardMediateList[this.currentMediateIndex].underlyingAmount =
          //首期 + 每月还款金额 * （分期数 - 已还期数） + 最后一期
          parseFloat(
            this.oneCardMediateList[this.currentMediateIndex]
              .fristIssueAmount == "" ||
              this.oneCardMediateList[this.currentMediateIndex]
                .fristIssueAmount == undefined
              ? 0
              : this.mediateData.fristIssueAmount
          ) +
          parseFloat(
            this.oneCardMediateList[this.currentMediateIndex].monthlyAmount ==
              "" ||
              this.oneCardMediateList[this.currentMediateIndex].monthlyAmount ==
              undefined
              ? 0
              : this.oneCardMediateList[this.currentMediateIndex].monthlyAmount
          ) *
          (parseFloat(
            this.oneCardMediateList[this.currentMediateIndex]
              .installmentNum == "" ||
              this.mediateData.installmentNum == undefined
              ? 0
              : this.oneCardMediateList[this.currentMediateIndex]
                .installmentNum
          ) -
            2) +
          parseFloat(
            this.oneCardMediateList[this.currentMediateIndex].lastIssueAmount ==
              "" || this.mediateData.lastIssueAmount == undefined
              ? 0
              : this.oneCardMediateList[this.currentMediateIndex]
                .lastIssueAmount
          );
        return this.oneCardMediateList[
          this.currentMediateIndex
        ].underlyingAmount.toFixed(2);
      },
      set(val) {
        if (val == "" || val == 0) {
          this.mediateMoney = "";
          this.oneCardMediateList[this.currentMediateIndex].underlyingAmount =
            //首期 + 每月还款金额 * （分期数 - 已还期数） + 最后一期
            parseFloat(
              this.oneCardMediateList[this.currentMediateIndex]
                .fristIssueAmount == "" ||
                this.mediateData.fristIssueAmount == undefined
                ? 0
                : this.oneCardMediateList[this.currentMediateIndex]
                  .fristIssueAmount
            ) +
            parseFloat(
              this.oneCardMediateList[this.currentMediateIndex].monthlyAmount ==
                "" || this.mediateData.monthlyAmount == undefined
                ? 0
                : this.oneCardMediateList[this.currentMediateIndex]
                  .monthlyAmount
            ) *
            (parseFloat(
              this.oneCardMediateList[this.currentMediateIndex]
                .installmentNum == "" ||
                this.mediateData.installmentNum == undefined
                ? 0
                : this.oneCardMediateList[this.currentMediateIndex]
                  .installmentNum
            ) -
              2) +
            parseFloat(
              this.oneCardMediateList[this.currentMediateIndex]
                .lastIssueAmount == "" ||
                this.mediateData.lastIssueAmount == undefined
                ? 0
                : this.oneCardMediateList[this.currentMediateIndex]
                  .lastIssueAmount
            );
        }
        if (val != null && val != undefined) {
          this.oneCardMediateList[this.currentMediateIndex].underlyingAmount =
            val;
          this.mediateMoney = val;
        }
      },
    },
    CunderlyingAmount: {
      get() {
        if (this.exeMoney != "") return this.exeMoney;
        {
          this.exeForm.underlyingAmount =
            parseFloat(
              this.exeForm.principal == "" ||
                this.exeForm.principal == undefined
                ? "0"
                : this.exeForm.principal
            ) +
            parseFloat(
              this.exeForm.interest == "" || this.exeForm.interest == undefined
                ? 0
                : this.exeForm.interest
            ) +
            parseFloat(
              this.exeForm.liquidatedDamages == "" ||
                this.exeForm.liquidatedDamages == undefined
                ? 0
                : this.exeForm.liquidatedDamages
            ) +
            parseFloat(
              this.exeForm.serviceCharge == "" ||
                this.exeForm.serviceCharge == undefined
                ? 0
                : this.exeForm.serviceCharge
            ) +
            parseFloat(
              this.exeForm.otherExpenses == "" ||
                this.exeForm.otherExpenses == undefined
                ? 0
                : this.exeForm.otherExpenses
            ) +
            parseFloat(
              this.exeForm.otherExpenses2 == "" ||
                this.exeForm.otherExpenses2 == undefined
                ? 0
                : this.exeForm.otherExpenses2
            );
          return this.exeForm.underlyingAmount;
        }
      },
      set(val) {
        if (val != null && val != undefined) {
          this.exeForm.underlyingAmount = val;
          this.exeMoney = val;
        } else if (val == "" || val == 0) {
          this.exeMoney = "";
          this.exeForm.underlyingAmount =
            parseFloat(
              this.exeForm.principal == "" ||
                this.exeForm.principal == undefined
                ? "0"
                : this.exeForm.principal
            ) +
            parseFloat(
              this.exeForm.interest == "" || this.exeForm.interest == undefined
                ? 0
                : this.exeForm.interest
            ) +
            parseFloat(
              this.exeForm.liquidatedDamages == "" ||
                this.exeForm.liquidatedDamages == undefined
                ? 0
                : this.exeForm.liquidatedDamages
            ) +
            parseFloat(
              this.exeForm.serviceCharge == "" ||
                this.exeForm.serviceCharge == undefined
                ? 0
                : this.exeForm.serviceCharge
            ) +
            parseFloat(
              this.exeForm.otherExpenses == "" ||
                this.exeForm.otherExpenses == undefined
                ? 0
                : this.exeForm.otherExpenses
            ) +
            parseFloat(
              this.exeForm.otherExpenses2 == "" ||
                this.exeForm.otherExpenses2 == undefined
                ? 0
                : this.exeForm.otherExpenses2
            );
        }
      },
    },
    TimeOrder: {
      get() {
        return this.val;
      },
      set(value) {
        this.CaseInfo.sort = "1";
        if (value == 1) {
          this.val = "降序";
          this.list.sort(function (a, b) {
            return (
              Date.parse(b.entrustmentDate.replace(/-/g, "/")) -
              Date.parse(a.entrustmentDate.replace(/-/g, "/"))
            );
          });
        } else {
          this.CaseInfo.sort = 0;
          this.val = "升序";
          this.list.sort(function (a, b) {
            return (
              Date.parse(a.entrustmentDate.split(" ")[0].replace(/-/g, "/")) -
              Date.parse(b.entrustmentDate.split(" ")[0].replace(/-/g, "/"))
            );
          });
        }
        this.getList();
      },
    },
  },
  methods: {
    previewFile(id) {
      previewUrl(id).then(res => {
        window.open(res);
      })
    },
    getFileList(id) {
      this.caseFilesList = [];
      getCaseUploadFile(id).then((res) => {
        if (res != [] && res.length > 0) {
          this.caseFilesList = res;
        }
      });
    },
    switchIndex(index) {
      this.currentMediateIndex = index;
    },
    setHKday(val) {
      this.mediateData.mouthlyPayDate = val;
    },
    deleteOneCardMediate(index) {
      if (
        this.oneCardMediateList[index].id == "" ||
        this.oneCardMediateList[index].id == null ||
        this.oneCardMediateList[index].id == undefined
      ) {
        this.oneCardMediateList.splice(index, 1);
        return;
      }
      let deleteId = this.oneCardMediateList[index].id;

      // for(let key in this.oneCardMediateList[index]){
      // if(this.oneCardMediateList[index][key] !== undefined){
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          deleteMediateData(this.oneCardMediateList[index].id).then((res) => {
            if (res.statusCode === 2000) {
              this.oneCardMediateList.splice(index, 1);
              for (let i = 0; i < this.mediateList.length; i++) {
                if (this.mediateList[i].id == deleteId)
                  this.mediateList.splice(i, 1);
              }

              this.$message.success("删除成功");
            }
          });
        })
        .catch((res) => {
          return;
        });
      // }
      // }
    },
    //调解方案
    addOneCardMediate() {
      this.oneCardMediateList.push({});
      this.activeIndexs.push(this.oneCardMediateList.length - 1);
    },

    //执行方案
    addOneCardExe() {
      if (this.exeForm.cardNumber == "" || this.exeForm.cardNumber == undefined) {
        this.$message({
          message: "请先选择一个卡号",
          duration: 4000,
          type: "error",
        });
        return;
      }
      calculationCardAmount(this.caseId).then((res) => {
        var obj = {
          id: "",
          caseId: this.caseId,
          registerCode: "",
          exeCode: "",
          underlyingAmount: res.total,
          principal: res.principal,
          interest: res.interest,
          liquidatedDamages: res.liquidatedDamages,
          serviceCharge: res.serviceCharge,
          otherExpenseName: "",
          otherExpenses: "",
          otherExpense2Name: "",
          otherExpenses2: "",
          exeFilingDate: "",
          exeUndertakeJudge: "",
          cardNumber: this.exeForm.cardNumber,
        };
        if (res.maps != undefined && res.maps.length == 1) {
          if (res.maps[0].description != undefined) {
            obj.otherExpenseName = res.maps[0].description;
          }
          if (res.maps[0].expenses != undefined) {
            obj.otherExpenses = res.maps[0].expenses;
          }
        }
        if (res.maps != undefined && res.maps.length == 2) {
          if (res.maps[1].description != undefined) {
            obj.otherExpenseName = res.maps[1].description;
          }
          if (res.maps[1].expenses != undefined) {
            obj.otherExpenses = res.maps[1].expenses;
          }
        }

        this.oneCardExeList.push(obj);
      });
      if (this.oneCardExeList.length != 0) {
        this.activeIndexs.push(this.oneCardExeList.length - 1);
      } else {
        this.activeIndexs.push(0);
      }
    },
    exportBatchNumber() {
      downLoadFile(
        this,
        {
          isValidate: false,
          fileNum: 0,
          method: "post",
          url: "/api/case/czCaseInfo/expBatchIdExcel",
        },
        (req) => {
          req.data = { batchId: this.batchNumber };
          return req;
        }
      );
      return;
    },

    /**调解方案选择卡号
     *  */
    changeCard(val) {
      this.getMediateData(val);
    },

    /**
     * 执行方案选择卡号
     */
    exeChangeCard(index) { },

    getCardNumber(val) {
      if (val.length > 0) {
        this.showMediateField = true;
      }
    },
    expProcessingFeeExcel() {
      downLoadFile(
        this,
        {
          isValidate: true,
          method: "post",
          url: "/api/case/czCaseInfo/expProcessingFeeExcel",
        },
        (req) => {
          req.params = { caseIdList: this.caseIdList };
          return req;
        }
      );
      return;
    },
    expLawyerExcel() {
      downLoadExcel(
        this,
        {
          isValidate: true,
          method: "post",
          url: "/api/case/czCaseInfo/expLawyerExcel",
        },
        (req) => {
          req.params = { caseIdList: this.caseIdList };
          return req;
        }
      );
      return;
    },

    /**
     * 导出开庭明细清单
     */
    expDiaodang() {
      downLoadFile(
        this,
        {
          isValidate: true,
          method: "post",
          url: "/api/case/czCaseInfo/expDiaodang",
        },
        (req) => {
          req.params = { caseIdList: this.caseIdList };
          return req;
        }
      );
      return;
    },

    /**
     * 导出结算表
     */
    expSettleExcel() {
      downLoadFile(
        this,
        {
          requireSelect: true,
          isValidate: true,
          method: "post",
          url: "/api/case/czSettlementData/expSettleExcel",
        },
        (req) => {
          req.params = { caseIdList: this.caseIdList };
          return req;
        }
      );
      return;
    },

    expPanJueExcel() {
      downLoadFile(
        this,
        {
          requireSelect: true,
          isValidate: true,
          method: "post",
          url: "/api/case/czCaseInfo/expPanJueExcel",
        },
        (req) => {
          req.params = { caseIdList: this.caseIdList };
          return req;
        }
      );
      return;
    },

    showCreateCase() {
      (this.centerDialogVisible = true), (this.CaseForm = {});
      this.formData = new FormData();
      this.fileList = [];
    },
    closeNotes() {
      this.notesText = "";
      this.showNotes = false;
    },
    addNotes() {
      if (this.caseIdList.length < 1) {
        this.$message.error("请勾选至少一个案件");
        return;
      }
      addCaseRemark({
        caseIdList: this.caseIdList,
        remark: this.notesText,
      }).then((res) => {
        this.$message.success("添加成功");
        this.closeNotes();
      });
    },
    setTableHeight(val) {
      localStorage.setItem("tableHeight", val);
      this.tableHeight = val;
    },
    changeLian(e) {
      if (e == "" || e == null || e == undefined) {
        this.value1 = "";
      }
    },
    changeMediateTime(e) {
      if (e == "" || e == null || e == undefined) {
        this.value2 = "";
      }
    },
    changeJudgeTime(e) {
      if (e == "" || e == null || e == undefined) {
        this.value3 = "";
      }
    },
    startDate(val, index) {
      this.mediateData.schemeStartDate = val;
      if (
        this.oneCardMediateList[index].schemeEndDate != null &&
        this.oneCardMediateList[index].schemeEndDate != undefined &&
        this.oneCardMediateList[index].schemeEndDate != "" &&
        this.oneCardMediateList[index].schemeStartDate != null &&
        this.oneCardMediateList[index].schemeStartDate != undefined &&
        this.oneCardMediateList[index].schemeStartDate != ""
      ) {
        Vue.set(
          this.oneCardMediateList[index],
          "installmentNum",
          MonthsBetw(
            this.oneCardMediateList[index].schemeStartDate,
            this.oneCardMediateList[index].schemeEndDate
          ) -
            1 ==
            0
            ? 1
            : MonthsBetw(
              this.oneCardMediateList[index].schemeStartDate,
              this.oneCardMediateList[index].schemeEndDate
            )
        );

        this.mediateData.installmentNum =
          MonthsBetw(
            this.oneCardMediateList[index].schemeStartDate,
            this.oneCardMediateList[index].schemeEndDate
          ) -
            1 ==
            0
            ? 1
            : MonthsBetw(
              this.oneCardMediateList[index].schemeStartDate,
              this.oneCardMediateList[index].schemeEndDate
            );

        if (
          this.oneCardMediateList[index].installmentNum < 0 ||
          this.oneCardMediateList[index].installmentNum == 0
        ) {
          this.$message({
            message: "方案开始日期必须在结束日期之前",
            duration: 4000,
            type: "error",
          });
          this.oneCardMediateList[index].schemeEndDate = "";
          this.oneCardMediateList[index].schemeStartDate = "";
          this.oneCardMediateList[index].installmentNum = "";
          this.mediateData.schemeEndDate = "";
          this.mediateData.schemeStartDate = "";
          this.mediateData.installmentNum = "";
        }
      } else {
        this.oneCardMediateList[index].installmentNum = "";
      }
    },
    endDate(val, index) {
      this.mediateData.schemeEndDate = val;
      if (
        this.oneCardMediateList[index].schemeEndDate != null &&
        this.oneCardMediateList[index].schemeEndDate != undefined &&
        this.oneCardMediateList[index].schemeEndDate != "" &&
        this.oneCardMediateList[index].schemeStartDate != null &&
        this.oneCardMediateList[index].schemeStartDate != undefined &&
        this.oneCardMediateList[index].schemeStartDate != ""
      ) {
        // this.oneCardMediateList[index].installmentNum =
        //   MonthsBetw(this.oneCardMediateList[index].schemeStartDate, this.oneCardMediateList[index].schemeEndDate) - 1 == 0 ? 1
        //     : MonthsBetw(this.oneCardMediateList[index].schemeStartDate, this.oneCardMediateList[index].schemeEndDate);
        Vue.set(
          this.oneCardMediateList[index],
          "installmentNum",
          MonthsBetw(
            this.oneCardMediateList[index].schemeStartDate,
            this.oneCardMediateList[index].schemeEndDate
          ) -
            1 ==
            0
            ? 1
            : MonthsBetw(
              this.oneCardMediateList[index].schemeStartDate,
              this.oneCardMediateList[index].schemeEndDate
            )
        );
        this.oneCardMediateList[index].installmentNum =
          MonthsBetw(
            this.oneCardMediateList[index].schemeStartDate,
            this.oneCardMediateList[index].schemeEndDate
          ) -
            1 ==
            0
            ? 1
            : MonthsBetw(
              this.oneCardMediateList[index].schemeStartDate,
              this.oneCardMediateList[index].schemeEndDate
            );
        let temp = this.oneCardMediateList[index];
        this.oneCardMediateList.splice(index, 1, temp);
        if (
          this.oneCardMediateList[index].installmentNum < 0 ||
          this.oneCardMediateList[index].installmentNum == 0
        ) {
          this.$message({
            message: "方案开始日期必须在结束日期之前",
            duration: 4000,
            type: "error",
          });
          this.oneCardMediateList[index].schemeEndDate = "";
          this.oneCardMediateList[index].schemeStartDate = "";
          this.oneCardMediateList[index].installmentNum = "";
          this.mediateData.schemeEndDate = "";
          this.mediateData.schemeStartDate = "";
          this.mediateData.installmentNum = "";
        }
      } else {
        this.oneCardMediateList[index].installmentNum = "";
      }
    },
    withDraw() {
      this.$refs.withDrawForm.validate((valid) => {
        if (valid) {
          this.btFlag = true;
          withDraw({
            userId: this.withDrawModel.mediateId,
            dropLawsuitDate: this.withDrawModel.date,
            dropLawsuitReason: this.withDrawModel.reason,
            caseId: this.id,
          })
            .then((res) => {
              if (res.statusCode == 2000) {
                this.$message({ message: "撤诉成功", type: "success" });
                this.getList();
                this.withDrawFormVisible = false;
              } else {
                this.btFlag = false;
              }
            })
            .catch((err) => {
              this.btFlag = false;
            });
        }
      });
    },
    backCase() {
      this.$refs.backCaseForm.validate((valid) => {
        if (valid) {
          this.btFlag = true;
          if (this.caseIdList.length > 0) {
            batchBackCase({
              withdrawalDate: this.backCaseModel.date,
              withdrawalReason: this.backCaseModel.reason,
              caseIdList: this.caseIdList,
            })
              .then((res) => {
                if (res.statusCode == 2000) {
                  this.$message({ message: "退案成功", type: "success" });
                  this.getList();
                  this.batchBackCaseFormVisible = false;
                  this.caseIdList = []
                } else {
                  this.btFlag = false;
                }
              })
              .catch((err) => {
                this.btFlag = false;
              });
          } else {
            backCase({
              withdrawalDate: this.backCaseModel.date,
              withdrawalReason: this.backCaseModel.reason,
              caseId: this.id,
            })
              .then((res) => {
                if (res.statusCode == 2000) {
                  this.$message({ message: "退案成功", type: "success" });
                  this.getList();
                  this.backCaseFormVisible = false;
                } else {
                  this.btFlag = false;
                }
              })
              .catch((err) => {
                this.btFlag = false;
              });
          }
        }
      });
    },
    changeVal(val) {
      if (val == "提交诉讼服务网") {
        this.caseDate = " 提交诉讼服务网时间";
      } else if (val == "提交法院") {
        this.caseDate = "提交法院日期";
      } else {
        this.caseDate = "";
      }
      k;
    },
    getCaseStatus(val) {
      this.getList();
    },
    getNumber(value, object, filed) {
      let val = "" + value;
      val =
        val
          .replace(/[^\d^\.]+/g, "")
          .replace(/^0+(\d)/, "$1")
          .match(/^\d*(\.?\d{0,2})/g)[0] || "";
      object[filed] = val;
    },

    getMediateData(cardNumber) {
      // let temp = this.oneCardMediateList.length > 0 ? this.oneCardMediateList:this.mediateList
      this.oneCardMediateList = [];
      let res;
      if (cardNumber) {
        for (let i = 0; i < this.mediateList.length; i++) {
          if (this.mediateList[i].cardNumber == cardNumber) {
            // this.oneCardMediateList.push()
            this.oneCardMediateList.push(this.mediateList[i]);
            res = this.mediateList[i];
          }
        }
        if (
          this.mediateList.length > 0 &&
          this.oneCardMediateList.length == 0
        ) {
          this.oneCardMediateList = this.mediateList;

          // res = this.mediateList[i]
        }
        return;

        if (res) {
          this.mediateData.cardNumber = res.cardNumber;
        }
      } else {
        if (
          this.mediateList.length > 0 &&
          this.oneCardMediateList.length == 0
        ) {
          this.oneCardMediateList = this.mediateList;

          // res = this.mediateList[i]
        }
        return;
      }
    },
    getMediateMessage() {
      getMediateMessage(this.id).then((response) => {
        this.mediateList = response;
        this.getMediateData(
          this.currentCardNumber && this.currentCardNumber != ""
            ? this.currentCardNumber
            : this.cardList.length > 0
              ? this.cardList[0].cardNumber
              : ""
        );
      });
    },
    updateMediateMessage(item, index) {
      this.oneCardMediateList[index].underlyingAmount =
        //首期 + 每月还款金额 * （分期数 - 已还期数） + 最后一期
        parseFloat(
          this.oneCardMediateList[index].fristIssueAmount == ""
            ? 0
            : this.oneCardMediateList[index].fristIssueAmount
        ) +
        parseFloat(
          this.oneCardMediateList[index].monthlyAmount == ""
            ? 0
            : this.oneCardMediateList[index].monthlyAmount
        ) *
        (parseFloat(
          this.oneCardMediateList[index].installmentNum == ""
            ? 0
            : this.oneCardMediateList[index].installmentNum
        ) -
          2) +
        parseFloat(
          this.oneCardMediateList[index].lastIssueAmount == ""
            ? 0
            : this.oneCardMediateList[index].lastIssueAmount
        );
      this.$refs.mediateForm[index].validate((valid) => {
        if (valid) {
          this.btFlag = true;
          this.mediateData.caseId = this.id;
          this.currentCardNumber = this.mediateData.cardNumber;
          updateMediateMessage(this.mediateData.id, item)
            .then((res) => {
              if (res.statusCode == 2000) {
                this.$message({ message: "更新成功", type: "success" });
                for (let key in this.mediateData) {
                  this.mediateData[key] = "";
                }
                this.schemeShow = false;
                this.getList();
                this.getMediateMessage();
              } else {
                this.btFlag = false;
                this.$message({ message: res.message, type: "error" });
              }
            })
            .catch((err) => {
              this.btFlag = false;
            });
        } else {
          return false;
        }
      });
    },
    submitMediateCase() {
      this.$confirm(
        "请确定所有调解方案已录入，否则无法正常提交案件，确定继续提交吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        submitMediateCase(this.id).then((res) => {
          if (res.statusCode == 2000) {
            this.$message.success("成功");
            this.schemeShow = false;
            this.getList();
          } else if (res.statusCode == 5000) {
            this.$message.error(res.message);
          }
        });
      });
    },
    addMediateMessage(item, index) {
      this.oneCardMediateList[index].underlyingAmount =
        //首期 + 每月还款金额 * （分期数 - 已还期数） + 最后一期
        parseFloat(
          this.oneCardMediateList[index].fristIssueAmount == ""
            ? 0
            : this.oneCardMediateList[index].fristIssueAmount
        ) +
        parseFloat(
          this.oneCardMediateList[index].monthlyAmount == ""
            ? 0
            : this.oneCardMediateList[index].monthlyAmount
        ) *
        (parseFloat(
          this.oneCardMediateList[index].installmentNum == ""
            ? 0
            : this.oneCardMediateList[index].installmentNum
        ) -
          2) +
        parseFloat(
          this.oneCardMediateList[index].lastIssueAmount == ""
            ? 0
            : this.oneCardMediateList[index].lastIssueAmount
        );
      if (item.id) {
        this.updateMediateMessage(item, index);
        return;
      }
      this.$refs["mediateForm"][index].validate((valid) => {
        if (valid) {
          this.btFlag = true;
          this.mediateData.mediateCode =
            "（" +
            this.mediateData.year +
            "）粤" +
            this.mediateData.code +
            this.mediateData.status +
            this.mediateData.mediateCod +
            "号";
          this.mediateData.caseId = this.id;
          this.currentCardNumber = this.mediateData.cardNumber;
          item.cardNumber = this.mediateData.cardNumber;
          item.caseId = this.id;
          addMediateMessage(item)
            .then((res) => {
              if (res.statusCode == 2000) {
                this.$message({ message: "录入成功", type: "success" });
                for (let i = 0; i < this.activeIndexs.length; i++) {
                  if (this.activeIndexs[i] == index) {
                    this.activeIndexs.splice(i, 1);
                    break;
                  }
                }
                for (let key in this.mediateData) {
                  if (key != "cardNumber") this.mediateData[key] = "";
                }
                this.btFlag = false;

                // this.schemeShow = false;
                this.getList();

                this.getMediateMessage();
              } else {
                this.btFlag = false;
                this.$message({ message: res.message, type: "error" });
              }
            })
            .catch((err) => {
              this.btFlag = false;
            });
        }
      });
    },

    addObj(item, index) {
      item.caseId = this.caseId;
      this.$refs["exeInfoForm"][index].validate((valid) => {
        if (valid) {
          this.btFlag = true;
          this.exeForm.exeCode = this.caseData.registerCode;
          addObj(item)
            .then((res) => {
              if (res.statusCode == 2000) {
                this.getExe(this.caseId, this.selectedCaseInfo);
                this.$message({ message: "录入成功", type: "success" });
                this.getList();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                  duration: 5000,
                });
                this.btFlag = false;
              }
            })
            .catch((err) => {
              this.btFlag = false;
            });
        } else {
          return false;
        }
      });
    },
    getExe(id, caseInfo) {
      getExecutePlan(id).then((res) => {
        if (res.length > 0) {
          var list = res;
          list.forEach(item => {
            Vue.set(item, 'caseFilingFee', caseInfo.caseFilingFee);
            Vue.set(item, 'propertyPreservationFee', caseInfo.propertyPreservationFee);
            Vue.set(item, 'announcementFee', caseInfo.announcementFee);
            if (caseInfo.executingLawyer != undefined && caseInfo.executingLawyer != null) {
              Vue.set(item, 'executingLawyers', caseInfo.executingLawyer.split(',').map(item => item.trim()).filter(item => item));
            }
          });
          this.oneCardExeList = list;

        } else {
          this.oneCardExeList = [];
        }
      });
    },
    putObj(item, index) {
      this.$refs["exeInfoForm"][index].validate((valid) => {
        if (valid) {
          this.btFlag = true;

          putObj(item)
            .then((res) => {
              if (res.statusCode == 2000) {
                this.$message({ message: "修改成功", type: "success" });
                this.getList();
                this.getExe(this.caseId, this.selectedCaseInfo);
              } else {
                this.btFlag = false;
                this.$message({
                  message: res.message,
                  type: "error",
                  duration: 5000,
                });
              }
            })
            .catch((err) => {
              this.btFlag = false;
            });
        }
      });
    },

    noPerformance(caseId) {
      noPerformance(caseId).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "成功", type: "success" });
        }
        this.getList();
      });
    },
    performance(obj) {
      performance(obj).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "成功", type: "success" });
          this.caseCompleDateVisible = false;
        }
        this.getList();
      });
    },
    fulfillmentDate() {
      this.$refs["performTimeForm"].validate((valid) => {
        if (valid) {
          this.btFlag = true;
          fulfillmentDate({
            caseId: this.id,
            fulfillmentDate: this.performTimeModel.performDate,
          })
            .then((res) => {
              this.btFlag = false;
              this.$message({ message: "履行时间录入成功", type: "success" });
              this.performShow = false;
              this.getList();
            })
            .catch((err) => {
              this.btFlag = false;
            });
        } else {
        }
      });
    },
    enterVerdict(caseId) {
      enterVerdict(caseId).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "确认开庭", type: "success" });
        }
        this.getList();
      });
    },
    confirmDiaoDang(caseId) {
      confirmDiaoDang(caseId).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "完成调档", type: "success" });
        }
        this.getList();
      });
    },
    switchRegister(caseId) {
      switchRegister(caseId).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "成功", type: "success" });
        }
        this.getList();
      });
    },
    expBankLedger() {
      let loading = this.$loading({
        lock: true,
        text: "正在生成银行台账",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.CaseInfo.caseIdList = this.caseIdList;

      const token = util.cookies.get("token");
      expBankExcel(this.CaseInfo, token).then((res) => {
        loading.close();
        const disposition = res.headers["content-disposition"];
        const fileName = decodeURI(disposition);
        let url = window.URL.createObjectURL(
          new Blob([res.data], { type: ".xls" })
        );
        let a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        url = window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      });
    },
    exByJieSuan() {
      let loading = this.$loading({
        lock: true,
        text: "正在生成。。。",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.CaseInfo.caseIdList = this.caseIdList;

      const token = util.cookies.get("token");
      expBankLedgerByJieSuan(this.CaseInfo, token).then((res) => {
        loading.close();
        const disposition = res.headers["content-disposition"];
        const fileName = decodeURI(disposition);
        let url = window.URL.createObjectURL(
          new Blob([res.data], { type: ".xls" })
        );
        let a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        url = window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      });
    },

    showPreview(id) {
      this.id = id;
    },
    handleCheckAllChange(val) {
      if (val == true) this.checkedDocument = this.documentType;
      else {
        this.checkedDocument = [];
      }
      this.isIndeterminate = false;
    },
    handleCheckedDocumentChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.documentType.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.documentType.length;
    },
    //生成诉讼服务网表格
    downloadWebExcel() {
      downLoadFile(
        this,
        {
          isValidate: true,
          url: "/api/case/czCaseInfo/expServiceWebExcel",
          fileType: ".xlsx",
        },
        (req) => {
          var formData = new FormData();
          formData.append("caseIdList", this.caseIdList);
          req.data = formData;
          return req;
        }
      );
    },
    //生成诉讼服务网执行案件表格
    expExeExcel() {
      downLoadFile(
        this,
        {
          isValidate: true,
          url: "/api/case/czCaseInfo/expExeExcel",
          fileType: ".xlsx",
        },
        (req) => {
          var formData = new FormData();
          formData.append("caseIdList", this.caseIdList);
          req.data = formData;
          return req;
        }
      );
    },
    createConstructionTable() {
      downLoadFile(
        this,
        { isValidate: true, url: "/api/case/czCaseInfo/createApprovalTable" },
        (req) => {
          req.data = {
            caseIdList: this.caseIdList,
            documentType: this.checkedDocument,
            dropOffDate: this.dropOffDate,
          };
          return req;
        }
      );
    },
    //生成高州起诉状
    createGaoZhouDoc() {
      downLoadFile(
        this,
        { url: "/api/case/czCaseInfo/createGaoZhouDocument", fileNum: 2 },
        (req) => {
          req.data = {
            caseIdList: this.caseIdList,
            documentType: this.checkedDocument,
            dropOffDate: this.dropOffDate,
          };
          return req;
        }
      );
      return;
    },
    backToStart(id) {
      backToStart(id).then((res) => {
        this.getList();
        this.$message({ message: res.message, type: "success" });
      });
    },
    //生成文书
    downloadDucument() {
      downLoadFile(
        this,
        { method: "post", url: "/api/case/czCaseInfo/createDocument" },
        (req) => {
          req.data = {
            caseIdList: this.caseIdList,
            documentType: this.checkedDocument,
            dropOffDate: this.dropOffDate,
          };
          return req;
        }
      );
      return;
    },
    exportLedger() {
      downLoadExcel(
        this,
        {
          requireSelect: true,
          isValidate: true,
          url: "/api/case/czCaseInfo/expLedger",
          fileType: ".xls",
        },
        (req) => {
          var params = this.CaseInfo;
          var formData = new FormData();
          formData.append("caseIdList", this.caseIdList);
          req.data = formData;
          return req;
        }
      );
      return;
    },
    exByGuiDangJiaoJie() {
      downLoadExcel(
        this,
        {
          requireSelect: true,
          isValidate: true,
          url: "/api/case/czCaseInfo/exByGuiDangJiaoJie",
          fileType: ".xlsx",
        },
        (req) => {
          var params = this.CaseInfo;
          var formData = new FormData();
          formData.append("caseIdList", this.caseIdList);
          req.data = formData;
          return req;
        }
      );
      return;
    },
    setEditCaseInfo() {
      if (this.editCase == undefined) {
        if (this.editCase.length == 0)
          for (let i = 0; i < this.list.length; i++) {
            Vue.set(this.list[i], "username", undefined);
            Vue.set(this.list[i], "show", false);
          }
      }
      for (let i = 0; i < this.list.length; i++) {
        for (let j = 0; j < this.editCase.length; j++) {
          if (this.list[i].id == this.editCase[j].caseId) {
            if (this.id != this.editCase[j].caseId) {
              Vue.set(
                this.list[i],
                "username",
                this.editCase[j].username + "正在编辑"
              );
            }
            this.list[i].show = true;
            break;
          } else {
            Vue.set(this.list[i], "username", undefined);
            Vue.set(this.list[i], "show", false);
          }
        }
      }
    },
    onMessage(res) {
      var json = eval("(" + res.data + ")");
      this.editCase = json.data;
      if (json.status == 200) {
        this.editCase = json.data;
      } else if (json.status == 201) {
        this.testVis = true;
        this.editCase = json.data;
      } else if (json.status == 202) {
        this.editCase = json.data;
        this.setEditCaseInfo();
      } else if (json.status == 203) {
        this.editCase = json.data;
        this.setEditCaseInfo();
      } else if (json.status == 400) {
        this.editCase = json.data;
        this.$notify({ title: "提示", message: "案件正在被编辑" });
      }
      let t = setInterval(() => {
        if (this.list != undefined && this.list != null) {
          this.setEditCaseInfo();
          clearInterval(t);
        }
      }, 1000);

      if (json.status == 201) {
        for (let i = 0; i < this.list.length; i++) {
          this.tempShow.push(this.list[i].show);
          this.list[i].show = false;
        }
      }
    },
    onError() { },
    onOpen() { },
    onclose() {
      this.reLink();
    },
    reLink() {
      let t = setInterval(() => {
        if (this.wst.readyState == 3) {
          this.initWebsocket();
          clearInterval(t);
        }
      }, 1000);
    },
    deadlinePayDate() {
      let yearFlag = false;
      let codeFlag = false;
      let dateFlag = false;
      let registerCodeFlag = false;
      this.$refs["paymentDate"].validate((valid) => {
        if (valid) {
          dateFlag = true;
        }
      });
      this.$refs["code"].validate((valid) => {
        if (valid) {
          codeFlag = true;
        }
      });
      this.$refs["registerCode"].validate((valid) => {
        if (valid) {
          registerCodeFlag = true;
        }
      });
      this.$refs["year"].validate((valid) => {
        if (valid) {
          yearFlag = true;
        }
      });
      if (
        yearFlag == true &&
        codeFlag == true &&
        registerCodeFlag == true &&
        dateFlag == true
      ) {
        this.btFlag = true;
        this.caseData.registerCode =
          `（${this.registerModel.year}）` +
          "粤" +
          this.registerModel.code +
          "民初" +
          this.registerModel.registerCode +
          "号";
        if (this.isBatchRegister) {
          let reqObj = {
            caseIdList: this.caseIdList,
            paymentDate: this.caseData.paymentDate,
            registerCode: this.caseData.registerCode,
            filingDate: this.caseData.filingDate,
          };
          let loading = this.$loading({
            lock: true,
            text: "正在批量立案。。。",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          batchRegister(reqObj)
            .then((res) => {
              loading.close();
              if (res.statusCode == 2000) {
                this.$message({ message: res.message, type: "success" });
                this.registerBoxShow = false;
                this.getList();
              } else {
                this.btFlag = false;
                this.$message({
                  message: res.message,
                  type: "error",
                  duration: 5000,
                });
              }
            })
            .catch((err) => {
              loading.close();
              this.btFlag = false;
            });
          this.caseIdList = []
          this.isBatchRegister = false;
          return;
        } else {
          deadlinePayDate(this.caseData)
            .then((res) => {
              this.btFlag = false;
              if (res.statusCode == 2000) {
                this.$message({ message: "录入成功", type: "success" });
                this.registerBoxShow = false;
                this.getList();
              } else {
                this.btFlag = false;
                this.$message({
                  message: res.message,
                  type: "error",
                  duration: 5000,
                });
              }
            })
            .catch((err) => {
              this.btFlag = false;
            });
        }
      }
    },
    reScheduleg(caseId) {
      reScheduleg(caseId).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: "重新排期", type: "success" });
          this.getList();
        }
      });
    },

    confirmPayment(caseId) {
      this.$confirm("是否确认缴费?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        confirmPayment(caseId).then((res) => {
          if (res.statusCode == 2000) {
            this.$message({ message: "确认缴费", type: "success" });
            this.getList();
          }
        });
      });
    },
    hearing() {
      this.$refs.hearingTimeform.validate((valid) => {
        if (this.caseIdList.length < 1) {
          this.$message.error("请勾选至少一个案件");
          return;
        }
        if (valid) {
          this.btFlag = true;
          setTrialDate({
            caseIdList: this.caseIdList,
            trialDate: this.hearingTimeModel.hearingDate,
            undertakeJudge: this.hearingTimeModel.judge,
          })
            .then((res) => {
              this.btFlag = false;
              if (res.statusCode == 2000) {
                this.$message({ message: "设置成功", type: "success" });
                this.getList();
                this.hearingShow = false;
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            })
            .catch((err) => {
              this.btFlag = false;
            });
        } else {
          return false;
        }
      });
    },

    /**设置结案日期 */
    setSettleDate() {
      this.$refs.proccessDateform.validate((valid) => {
        if (this.caseIdList.length < 1) {
          this.$message.error("请勾选至少一个案件");
          return;
        }
        if (valid) {
          this.btFlag = true;
          settleDate({
            caseIdList: this.caseIdList,
            settleDate: this.proccessDateModel.settleDate,
            process: this.proccessDateModel.processValue,
          })
            .then((res) => {
              this.btFlag = false;
              if (res.statusCode == 2000) {
                this.$message({ message: "设置成功", type: "success" });
                this.getList();
                this.settleDateShow = false;
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            })
            .catch((err) => {
              this.btFlag = false;
            });
        } else {
          return false;
        }
      });
    },

    dropLawsuitRulingConfirm() {
      confirmDropLawsuit(this.dropLawsuitRulingModel).then((res) => {
        if (res.statusCode == 2000) {
          this.$message({ message: res.message, type: "success" });
          this.getList();
          this.dropLawsuitRulingShow = false;
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });
    },

    setMediateDate() {
      this.$refs.mediateForm.validate((valid) => {
        if (valid) {
          this.$refs.mediateTimeform.validate((valid) => {
            if (valid) {
              this.btFlag = true;
              setMediateDate({
                caseId: this.id,
                registerCode:
                  "（" +
                  this.mediateData.year +
                  "）粤" +
                  this.mediateData.code +
                  this.mediateData.status +
                  this.mediateData.mediateCod +
                  "号",
                userId: this.mediateTimeModel.mediateId,
                mediationDate: this.mediateTimeModel.mediateDate,
                filingDate: this.mediateTimeModel.filingDate,
              })
                .then((res) => {
                  if (res.statusCode == 2000) {
                    this.$message({ message: "调解成功", type: "success" });
                    this.mediateTimeShow = false;
                    this.getList();
                  } else {
                    this.btFlag = false;
                  }
                })
                .catch((err) => {
                  this.btFlag = false;
                });
            }
          });
        } else {
          return false;
        }
      });
    },
    closeDia() {
      this.wst.send("0");
      this.headrt = 240;
    },
    getObjToForm(caseId) {
      getExecutePlan(caseId).then((res) => { });
    },
    handleCommand(command) {
      if (command == "batchRegister") {
        if (this.caseIdList.length < 1) {
          this.$message.error("请勾选至少一个案件");
          return;
        }
        this.isBatchRegister = true;
        this.registerBoxShow = true;
      }
      if (command == "setAgent") {
        this.setAgentdialogVisible = true;
        return;
      }
      if (command == "batchBackCase") {
        this.backCaseModel.date = "";
        this.backCaseModel.reason = "";
        if (this.caseIdList.length < 1) {
          this.$message.error("请勾选案件");
          return;
        }
        this.batchBackCaseFormVisible = true;
        return;
      }
      if (command == "setStatus") {
        this.setStatusdialogVisible = true;
        this.plStatus.caseSt = "";
        this.plStatus.date = "";
        this.caseDate = "";
        return;
      }
      if (command == "batchDelete") {
        this.batchDelete();
        return;
      }
      if (command == "batchCreateDoc") {
        this.documentDialogVisible = true;
        return;
      }
      if (command == "exportInnerDoc") {
        this.exportLedger();
      }
      if (command == "exportBankDoc") {
        this.expBankLedger();
      }
      if (command == "exByJieSuan") {
        this.exByJieSuan();
      }
      if (command == "exByGuiDangJiaoJie") {
        this.exByGuiDangJiaoJie();
      }
      if (command == "exportBatchNumber") {
        this.batchDialog = true;
      }
      if (command == "expLawyerExcel") {
        this.expLawyerExcel();
      }
      if (command == "expProcessingFeeExcel") {
        this.expProcessingFeeExcel();
      }
      if (command == "notes") {
        this.showNotes = true;
      }
      if (command == "createGaoZhouDoc") {
        this.documentDialogVisibleByGaoZhou = true;
        return;
        this.createGaoZhouDoc();
      }
      if (command == "createConstructionTable") {
        this.createConstructionTable();
      }
      if (command == "expWebExcel") {
        this.downloadWebExcel();
        return;
      }
      if (command == "expExeExcel") {
        this.expExeExcel();
        return;
      }
      if (command == "hearing") {
        this.hearingTimeModel.hearingDate = "";
        this.hearingTimeModel.judge = "";
        this.hearingShow = true;
        return;
      }
      if (command == "settleDate") {
        this.proccessDateModel.settleDate = "";
        this.proccessDateModel.process = "";
        this.settleDateShow = true;

        return;
      }
      if (command == "batchUpdateSettleDate" || command == "batchUpdateMaterial" || command == "importExeCaseExcel") {
        this.uploadExcelFileVisible = true;
        // this.$refs.uploadSettleExcel.$el
        //   .querySelector(".upload-button")
        //   .click();
        this.uploadType = command
      }
      if (command == "expDiaodang") {
        if (this.caseIdList.length < 1) {
          this.$message.error("请勾选至少一个案件");
          return;
        }
        this.expDiaodang();
        return;
      }
      if (command == "expSettleExcel") {
        this.expSettleExcel();
        return;
      }
      if (command == "expPanJueExcel") {
        this.expPanJueExcel();
        return;
      }
      switch (command.command) {
        case "extryExe":
          // this.isEdit = false;
          // this.mediateData.status = "执";
          // this.exeFormVisible = true;
          // for (let key in this.exeForm) {
          //   this.exeForm[key] = "";
          // }
          // for (let key in this.mediateData) {
          //   this.mediateData[key] = "";
          // }
          // this.mediateData.year = "2024";
          // this.mediateData.status = "执";
          // this.exeForm.caseId = command.row.id;
          this.oneCardExeList = [];
          getCastAllInfo({ caseId: command.row.id }).then((res) => {
            this.selectedCaseInfo = res;
            this.cardList = res.cardInfoList;
            this.getExe(command.row.id, res);
          });
          this.caseId = command.row.id;
          this.exeFormVisible1 = true;

          break;
        case "editExe":
          this.isEdit = true;
          this.exeFormVisible = true;
          this.caseId = command.row.id;
          break;
        case "pay":
          this.confirmPayment(command.row.id);
          break;
        //发送请求修改状态为开庭排期中
        case "hearing":
          //输入开庭时间
          this.id = command.row.id;
          this.caseIdList.push(command.row.id);
          this.hearingTimeModel.hearingDate = "";
          this.hearingTimeModel.judge = "";
          this.hearingShow = true;
          break;
        case "transfer":
          this.$confirm("是否确认完成调档?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.confirmDiaoDang(command.row.id);
          });
          //修改状态为待开庭
          break;
        case "scheduling":
          this.$confirm("是否确认重新排期?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.reScheduleg(command.row.id);
          });
          //排期
          break;
        case "affirmHearing":
          this.$confirm("是否确认开庭?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.enterVerdict(command.row.id);
          });
          // this.getList();
          //修改状态为判决中
          break;
        case "hearingEnd":
          //输入判决生效日期
          this.id = command.row.id;
          this.performTimeModel.performDate = "";
          this.performShow = true;
          break;

        case "agreement":
          //完成履约
          break;
        case "carry":
          //未完成履约
          this.$confirm("是否确认申请执行?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.exeForm = {}
            this.oneCardExeList = [];
            getCastAllInfo({ caseId: command.row.id }).then((res) => {
              if (res.cause == '信用卡纠纷') {
                this.cardList = res.cardInfoList;
              } else {
                this.cardList = []
              }

              this.getExe(command.row.id, res);
            });
            this.caseId = command.row.id;
            this.isMedEdit = false;
            this.exeFormVisible1 = true;
          });

          break;
        case "addSingle":
          this.fileList = [];
          this.fileData = new FormData();
          this.id = command.row.id;
          this.addSingleDefendantDialog = true;
          break;
        case "edit":

          this.testVis = true;
          this.id = command.row.id;
          this.currentRow = command.row;
          this.listIndex = command.index;
          this.currentList = this.list;
          this.wst.send(this.id);
          this.headrt = 240;

          break;
        case "copy":
          this.id = command.row.id;
          copyCaseById(this.id).then((response) => {
            if (response.statusCode == 200) {
              this.$message({ message: "复制成功", type: "success" });
              this.getList();
            } else {
              this.$message.error("复制失败");
            }
          });

          break;
        case "preview":
          this.id = command.row.id;
          this.isPreview = true;
          break;
        case "delete":
          this.delCase(command.row.id);
          break;
        case "djf":
          this.caseData.caseId = command.row.id;
          this.registerBoxShow = true;

          this.caseData.paymentDate = "";
          this.registerModel.code = "";
          this.registerModel.registerCode = "";
          this.caseData.registerCode = "";
          this.code = "";
          break;
        case "upload":
          this.id = command.row.id;
          this.caseUploadShow = true;
          this.fileUrl = ''
          break;
        case "entryscheme":
          for (let key in this.mediateData) {
            this.mediateData[key] = "";
          }
          // for(let key in this.){
          //       this.
          // }
          getCastAllInfo({ caseId: command.row.id }).then((res) => {
            this.cardList = res.cardInfoList;
            this.mediateData["cardNumber"] =
              this.cardList.length > 0 ? this.cardList[0].cardNumber : "";
            this.mediateData.year = "2024";
            this.isMedEdit = false;
            this.currentCardNumber = "";
            this.schemeShow = true;
            this.id = command.row.id;

            this.getMediateMessage();
          });

          break;
        case "agreementEnd":
          this.$confirm(
            "是否确认结案？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          ).then(() => {
            this.caseCompleDateVisible = true;
            this.caseId = command.row.id;
          });
          //完成履约
          break;
        case "switchRegister":
          this.$confirm("是否确认转立案?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.switchRegister(command.row.id);
          });
          break;
        case "backToStart":
          this.$confirm("是否回退至提交法院?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.backToStart(command.row.id);
          });
          break;
        case "withDraw":
          this.id = command.row.id;
          this.withDrawFormVisible = true;
          this.withDrawModel.date = "";
          this.withDrawModel.reason = "";
          this.withDrawModel.mediateId = "";
          break;
        case "backCase":
          this.id = command.row.id;
          this.backCaseFormVisible = true;
          this.backCaseModel.date = "";
          this.backCaseModel.reason = "";
          break;
        case "mediate":
          this.$confirm("是否确认转调解?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            caseMediate(command.row.id).then((res) => {
              if (res.statusCode == 2000) {
                this.$message({ type: "success", message: "转调解" });
                this.getList();
              }
            });
          });
          break;
        case "mediateEnd":
          this.id = command.row.id;
          this.mediateTimeModel.mediateDate = "";
          this.mediateTimeModel.filingDate = "";
          this.mediateTimeModel.mediateId = "";
          this.mediateData.mediateCod = "";
          this.mediateData.code = "";
          this.mediateData.status = "";
          this.mediateTimeShow = true;
          break;
        //修改状态为调解中
        //修改状态
        case "editMediate":
          this.schemeShow = true;
          this.isMedEdit = true;
          this.id = command.row.id;
          this.currentCardNumber = "";
          getCastAllInfo({ caseId: command.row.id }).then((res) => {
            this.cardList = res.cardInfoList;
            this.mediateData["cardNumber"] =
              this.cardList.length > 0 ? this.cardList[0].cardNumber : "";
            this.getMediateMessage();
          });
          break;
        case "caseArchiving":
          //归档日期
          this.caseEndModelShow = true;
          this.caseEndModel.caseId = command.row.id;
          this.caseEndModel.archivingDate = "";
          break;
        case "withDrawConfirm":
          this.dropLawsuitRulingShow = true;
          this.dropLawsuitRulingModel.caseId = command.row.id;
          this.dropLawsuitRulingModel.registerCode = command.row.registerCode;
          break;
        case "backCaseStatus":
          this.backCaseStatusVisible = true
          this.id = command.row.id;
          break;
        default:
          break;
      }
    },
    showEditPage(index, row) {
      if (row.caseStatus === "处置中" || row.caseStatus === "未处置") {
        this.testVis = true;
        this.id = row.id;
        this.currentRow = row;
        this.listIndex = index;
        this.currentList = this.list;
        this.headrt = 240;
      } else {
        this.id = row.id;
        this.isPreview = true;
        return;
      }
    },
    /**
     * 删除单个案件
     * @param {} id
     */
    delCase(id) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deletetCase(id).then((res) => {
          this.$notify({
            title: "成功",
            message: res.message,
            type: "success",
            duration: 2000,
          });
          this.getList();
        });
      });
    },

    /**
     * 删除执行方案
     */
    delExe(index, item) {
      if (
        this.oneCardExeList[index].id == "" ||
        this.oneCardExeList[index].id == null ||
        this.oneCardExeList[index].id == undefined
      ) {
        this.oneCardExeList.splice(index, 1);
        return;
      } else {
        this.$confirm("此操作将永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          delExe(item.id).then((res) => {
            if (res.statusCode === 2000) {
              this.getExe(item.caseId, this.selectedCaseInfo);
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.message);
            }
          });
        });
      }
    },

    submitExeCase() {
      this.$confirm("是否提交案件？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.executionDate == '' || this.executionDate == null) {
          this.$message({ duration: 5000, message: "提交失败，请选择申请执行日期！", type: "error" });
          return;
        }
        let data = {
          id: this.caseId,
          executionDate: this.executionDate,
          referenceNumber: this.referenceNumber,
          caseFilingFee: this.caseFilingFee,
          propertyPreservationFee: this.propertyPreservationFee,
          announcementFee: this.announcementFee,
          operativePart: this.operativePart,
        }
        submitExeCase(data).then((res) => {
          if (res.statusCode === 2000) {
            this.getExe(this.caseId, this.selectedCaseInfo);
            this.getList();
            this.$message.success("提交成功");
            this.exeFormVisible1 = false;
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    /**
     * 案件完成
     */
    caseCompleDateReq() {
      if (this.caseCompleDate == '' || this.caseCompleDate == null) {
        this.$message({ duration: 5000, message: "结案失败，请选择结案日期", type: "error" });
        return;
      }
      let data = { id: this.caseId, caseCompleDate: this.caseCompleDate }
      this.performance(data)
    },

    editExeInfo() {
      this.$refs["exeInfoDataForm"].validate((valid) => {
        if (valid) {
          submitExeInfo({
            exeCode:
              "（" +
              this.exeInfoData.year +
              "）粤" +
              this.exeInfoData.code +
              this.exeInfoData.status +
              this.exeInfoData.num +
              "号",
            caseId: this.caseId,
            exeUndertakeJudge: this.exeInfoData.exeUndertakeJudge,
            exeFilingDate: this.exeInfoData.exeFilingDate,
          }).then((res) => {
            if (res.statusCode === 2000) {
              this.getList();
              this.$message.success("提交成功");
              this.exeFormVisible = false;
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },

    /**
     * 批量删除
     */
    batchDelete() {
      if (this.caseIdList.length < 1) {
        this.$message.error("请勾选案件");
        return;
      }
      var formData = new FormData();
      formData.append("caseIdList", this.caseIdList);
      this.$confirm("确认删除所选案件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        batchDeletetCase(formData).then((res) => {
          this.$notify({
            title: "操作结果",
            message: res.message,
            type: res.statusCode === 2000 ? "success" : "error",
            duration: 2000,
          });
          this.getList();
        });
      });
    },
    getTableUrl() {
      return process.env.VUE_APP_API + "/czCaseInfo/importCaseExcel";
    },
    getSettleUrl() {
      return process.env.VUE_APP_API + "/czCaseInfo/batchUpdateSettleDate";
    },
    getSingleloadUrl() {
      return (
        process.env.VUE_APP_API + "/api/case/czCaseInfo/addSingleDefendant"
      );
    },
    getCaseUploadUrl() {
      return (
        process.env.VUE_APP_API + "/api/case/czCaseInfo/czCaseFiles/upload"
      );
    },
    show() {
      this.addSingleDefendantDialog = true;
    },
    showDialog(index, row, command) {
      return { index: index, row: row, command: command };
    },
    addCaseFile() {
      this.addCaseFileShow = false;
      this.$refs.caseUpload.submit();
      this.fileData.append("caseId", this.id);
      let loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      upLoadCaseFile(this.fileData).then((res) => {
        loading.close();
        this.fileList = [];
        this.fileData = new FormData();
        if (res.statusCode == 2000) {
          this.$message({
            duration: 5000,
            message: "上传成功",
            type: "success",
          });
        } else {
          this.$message({ duration: 5000, message: "上传失败", type: "error" });
        }
        this.caseUploadShow = false;
      });
    },

    addSingleDefendant() {
      this.addSingleDefendantDialog = false;
      this.$refs.upload1.submit();
      this.fileData.append("caseId", this.id);
      addSingleDefendant(this.fileData).then((response) => {
        let str = response.message;
        if (str.includes("失败")) {
          this.$message({ duration: 5000, message: "添加失败", type: "error" });
        } else {
          this.$message({
            duration: 5000,
            message: "添加成功",
            type: "success",
          });
        }
        this.getList();
      });
    },
    search() {
      if (
        this.CaseInfo.entrustmentDate &&
        this.CaseInfo.entrustmentDate.length > 0
      ) {
        this.CaseInfo.entrustmentDateS = this.CaseInfo.entrustmentDate[0];
        this.CaseInfo.entrustmentDateE = this.CaseInfo.entrustmentDate[1];
      } else {
        this.CaseInfo.entrustmentDateS = "";
        this.CaseInfo.entrustmentDateE = "";
      }
      if (this.CaseInfo.trialDate && this.CaseInfo.trialDate.length > 0) {
        this.CaseInfo.trialDateS = this.CaseInfo.trialDate[0];
        this.CaseInfo.trialDateE = this.CaseInfo.trialDate[1];
      } else {
        this.CaseInfo.trialDateS = "";
        this.CaseInfo.trialDateE = "";
      }
      if (
        this.value1 != undefined &&
        this.value1 != "" &&
        this.value1 != null &&
        this.value1.length > 0
      ) {
        this.CaseInfo.filingStartDate = this.value1[0];
        this.CaseInfo.filingEndDate = this.value1[1];
      } else {
        this.CaseInfo.filingStartDate = "";
        this.CaseInfo.filingEndDate = "";
      }
      if (
        this.value2 != undefined &&
        this.value2 != "" &&
        this.value2 != null &&
        this.value2.length > 0
      ) {
        this.CaseInfo.mediationSuccessStartDate = this.value2[0];
        this.CaseInfo.mediationSuccessEndDate = this.value2[1];
      } else {
        this.CaseInfo.mediationSuccessStartDate = "";
        this.CaseInfo.mediationSuccessEndDate = "";
      }
      if (
        this.value3 != undefined &&
        this.value3 != "" &&
        this.value3 != null &&
        this.value3.length > 0
      ) {
        this.CaseInfo.decisionStartDate = this.value3[0];
        this.CaseInfo.decisionEndDate = this.value3[1];
      } else {
        this.CaseInfo.decisionStartDate = "";
        this.CaseInfo.decisionEndDate = "";
      }
      if (
        this.CaseInfo.courtSubDate && this.CaseInfo.courtSubDate.length > 0
      ) {
        this.CaseInfo.courtSubDateStart = this.CaseInfo.courtSubDate[0];
        this.CaseInfo.courtSubDateEnd = this.CaseInfo.courtSubDate[1];

      } else {
        this.CaseInfo.courtSubDateStart = ''
        this.CaseInfo.courtSubDateEnd = ''
      }
      if (this.CaseInfo.exeFilingDate && this.CaseInfo.exeFilingDate.length > 0) {
        this.CaseInfo.exeFilingDateStart = this.CaseInfo.exeFilingDate[0];
        this.CaseInfo.exeFilingDateEnd = this.CaseInfo.exeFilingDate[1];
      } else {
        this.CaseInfo.exeFilingDateStart = ''
        this.CaseInfo.exeFilingDateEnd = ''
      }

      this.CaseInfo.page = 1;
      this.getList();
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
      this.fileData.append("fields", file); // append增加数据
    },
    HttpUploadFile(val) {
      this.fileData.append("fields", val.file);
    },
    singleUploadFile(val) {
      let loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const token = util.cookies.get("token");
      this.fileData.append("file", val.file);
      uploadTable(this.fileData, token)
        .then((res) => {
          loading.close();
          if (res.data.statusCode === 2000) {
            this.$message.success(res.data.message);
            this.getList();
            this.fileData = new FormData();
            this.fileList = [];
          } else {
            this.$message.error("失败");
            this.fileData = new FormData();
            this.fileList = [];
          }
        })
        .catch((err) => {
          loading.close();
          this.$message.error("文件格式有问题或文件类型不符合");
          this.fileData = new FormData();
          this.fileList = [];
        });
    },
    uploadExcelFile(val) {
      let loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const token = util.cookies.get("token");
      this.fileData.append("file", val.file);
      this.fileData.append("bank", this.uploadExcelBank);
      this.fileData.append("idCardPageNum", this.idCardPageNum);
      var url;
      //导入结算表
      if (this.uploadType == "batchUpdateSettleDate") {
        url = "/api/case/czCaseInfo/batchUpdateSettleDate"
      }
      //导入原材料
      if (this.uploadType == "batchUpdateMaterial") {
        url = "/api/case/czCaseInfo/identifySourceDocumentation"
      }
      //导入执行案件
      if (this.uploadType == "importExeCaseExcel") {
        url = "/api/case/czCaseInfo/importExeCaseExcel"
      }
      uploadSingleFile(
        this.fileData,
        token,
        url
      ).then((res) => {
        loading.close();

        if (res.data.statusCode === 2000) {
          if (this.uploadType == "importExeCaseExcel") {
            this.$message({
              showClose: true,
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: res.data.message,
            });
          } else {
            var arr = res.data.data;
            var resMessage = "";
            for (var i = 0; i < arr.length; i++) {
              resMessage =
                resMessage + "<p><strong><i>" + arr[i] + "</i> </strong></p>";
            }
            this.$message({
              showClose: true,
              duration: 0,
              dangerouslyUseHTMLString: true,
              message: resMessage,
            });
          }

          this.uploadExcelFileVisible = false;
          this.getList();
          this.fileData = new FormData();
          this.fileList = [];
        } else {
          this.$message.error("失败");
          this.fileData = new FormData();
          this.fileList = [];
        }

      })
        .catch((err) => {
          loading.close();
          this.$message.error("文件格式有问题或文件类型不符合");
          this.fileData = new FormData();
          this.fileList = [];
        });
    },

    singFileChange(file, fileList) {
      this.fileList = fileList;
    },
    getUploadUrl() {
      return process.env.VUE_APP_API + "/api/case/czCaseInfo/caseBaseInfo";
    },
    submitForm(formName) {
      let loading;
      this.fullscreenLoading = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          const token = util.cookies.get("token");
          this.$refs.upload.submit();
          this.fileData.append("bankId", this.CaseForm.bankId);
          this.fileData.append("batchId", this.CaseForm.batchId);
          this.fileData.append(
            "entrustmentDate",
            this.CaseForm.entrustmentDate
          );
          this.fileData.append("cause", this.CaseForm.cause);
          this.fileData.append("cardNumber", this.CaseForm.cardNumber);
          this.fileData.append("caseType", this.CaseForm.caseType);
          addCaseInfo(this.fileData, token).then((response) => {
            if (response.data.statusCode === 2000) {
              this.centerDialogVisible = false;
              this.$message({
                duration: 5000,
                message: response.data.message,
                type: "success",
              });
              this.getList();
              this.fullscreenLoading = true;
              loading.close();
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    uploadSettleExcelClick() {
      if (this.uploadType == 'batchUpdateMaterial') {
        if (this.uploadExcelBank == null || this.uploadExcelBank == '') {
          this.$message({
            duration: 3000,
            message: '请选择银行',
            type: "error",
          });
          return;
        }
      }
      this.$refs.uploadSettleExcel.$el
        .querySelector(".upload-button")
        .click();
    },
    initWebsocket() {

      let host = process.env.VUE_APP_API.slice(7);
      if (!host.includes("127.0.0.1")) {
        //创建webSocket对象
        this.wst = new WebSocket(
          "wss://" + host + "/ws/case/websocket/edit/" + this.userId
        );
        let timeout = setInterval(() => {
          this.wst.send("-2");
          this.headrt--;
          if (this.headrt == 0) {
            this.wst.close();
            clearInterval(timeout);
          }
        }, 60001);
        this.wst.onopen = this.onOpen();
        this.wst.onmessage = this.onMessage;
        this.wst.onclose = this.onclose;
      }

    },
    getList() {
      this.caseIdList = []
      this.fileData = new FormData();
      this.listLoading = true;
      page(this.CaseInfo).then((response) => {
        this.btFlag = false;
        this.list = [];
        this.list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          if (
            response.records[i].registerCode != null &&
            response.records[i].registerCode != undefined &&
            response.records[i].registerCode != ""
          ) {
            this.list[i].registerCode = response.records[i].registerCode;
          } else if (
            response.records[i].mediationCode != null &&
            response.records[i].mediationCode != undefined &&
            response.records[i].mediationCode != ""
          ) {
            this.list[i].registerCode = response.records[i].mediationCode;
          } else {
            this.list[i].registerCode = "";
          }
        }
        this.total = response.total;
        this.listLoading = false;
        for (let i = 0; i < this.list.length; i++) {
          this.isShowList[i] =
            this.list[i].caseStatus == "未处置" ||
            this.list[i].caseStatus == "处置中" ||
            this.list[i].caseStatus == "提交诉讼服务网";
        }
        var inter = setInterval(() => {
          if (this.wst != undefined && this.wst.readyState == 1) {
            this.wst.send("-2");
            this.headrt = 240;
            clearInterval(inter);
          } else {
          }
        }, 1000);
      });
    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.CaseInfo.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.CaseInfo.page = val;
      this.getList();
    },
    cancel(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    //下载模板
    downloadTemplate(name) {
      const encodedKeyword = encodeURIComponent(name);
      downLoadFile(
        this,
        {
          isValidate: false,
          fileNum: 0,
          method: "get",
          url: "/api/case/caseFileTemplate/downloadTemplateName/" + encodedKeyword,
        },
        (req) => {
          req.data = { batchId: this.batchNumber };
          return req;
        }
      );
      return;
    },
    update(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          this.form.password = undefined;
          putObj(this.form.id, this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "更新成功",
              type: "success",
              duration: 2000,
            });
          });
        } else {
          return false;
        }
      });
    },
    towNumber(val) {
      if (val.toFixed(2) < 0) {
        return 0;
      }
      return val.toFixed(2)
    },
    /**
     * 多选框选择方法
     * @param {} val
     */
    handleSelectionChange(val) {
      let arr = [];
      let i = 0;
      for (let j = 0; j < this.list.length; j++) {
        Vue.set(this.list[j], "number", "");
      }
      for (let item of val) {
        Vue.set(item, "number", ++i);
        arr.push(item.id);
      }
      this.caseIdList = arr;
    },
    /**
     * 设置代理人
     */
    setCaseStatus() {
      if (this.caseIdList.length < 1) {
        this.$message.error("请勾选案件");
        return;
      }
      this.$refs.plCaseForm.validate((valid) => {
        if (valid) {
          var formData = new FormData();
          formData.append("status", this.plStatus.caseSt);
          formData.append("caseIdList", this.caseIdList);
          formData.append(
            "date",
            this.plStatus.date == "" ? "" : this.plStatus.date
          );
          setCaseStatus(formData).then((res) => {
            this.$notify({
              title: res.statusCode == 2000 ? "成功" : "失败",
              message: res.message,
              type: res.statusCode == 2000 ? "success" : "error",
              duration: 2000,
            });
            this.getList();
            this.setStatusdialogVisible = false;
          });
        }
      });
    },
    backCaseStatus() {
      this.$refs.backStatusInfoForm.validate((valid) => {
        if (valid) {
          var formData = new FormData();
          formData.append("caseId", this.id);
          formData.append("name", this.backStatusInfo.name);
          formData.append("status", this.backStatusInfo.status);
          backCaseStatusApi(formData).then(res => {
            if (res.statusCode === 2000) {
              this.$message.success(res.message);
              this.getList()
            } else {
              this.$message.error(res.message);
            }
          })
        }
      });
    },
    setCaseArchivingDate() {
      this.$refs.archivingDateForm.validate((valid) => {
        if (valid) {
          setArchivingDate({
            caseId: this.caseEndModel.caseId,
            archivingStatus: this.caseEndModel.archivingStatus,
            archivingDate: this.caseEndModel.archivingDate
          }).then(res => {
            if (res.statusCode === 2000) {
              this.$message.success(res.message);
              this.getList()
            } else {
              this.$message.error(res.message);
            }
          })
        }
      });
    },
    setAgent() {
      if (this.caseIdList.length < 1) {
        this.$message.error("请勾选案件");
        return;
      }
      if (this.setAgentId == null && this.setAgentId == undefined) {
        this.$message.error("请选择律师");
        return;
      }
      var formData = new FormData();
      formData.append("agentIdList", this.setAgentId);
      formData.append("caseIdList", this.caseIdList);
      setAgent(formData).then((res) => {
        this.$notify({
          title: "操作结果",
          message: res.message,
          type: res.statusCode === 2000 ? "success" : "error",
          duration: 2000,
        });
      });
      this.setAgentdialogVisible = false;
    },
    resetTemp() {
      this.CaseInfo = {
        caseCode: "",
        founder: "",
        batchId: "",
        plaintiffName: "",
        defendantName: "",
        underlyingAmount: "",
        entrustmentDate: "",
        trialDateS: "",
        caseStatus: [],
        courtName: "",
        agent: "",
        cardNum: "",
        page: 1,
        limit: 50,
        filingStartDate: "",
        filingEndDate: "",
        mediationSuccessStartDate: "",
        mediationSuccessEndDate: "",
        courtSubDateStart: "",
        courtSubDateEnd: "",
        exeFilingDateStart: "",
        exeFilingDateEnd: "",
        decisionStartDate: "",
        decisionEndDate: "",
      };
      this.value1 = "";
      this.value2 = "";
      this.value3 = "";
      this.getList();
    },
    addUploadRecord(val) {
      directUpload(val).then(res => {
        this.$notify({
          title: res.statusCode == 2000 ? "成功" : "失败",
          message: res.message,
          type: res.statusCode == 2000 ? "success" : "error",
          duration: 2000,
        });
        this.getList()
      }).catch(res => {
        this.$notify({
          title: "上传报错",
          message: '服务器处理文件失败',
          type: "error",
          duration: 3000,
        });
      })
    }
  },
};
</script>
<style>
.el-input__suffix {
  line-height: 40px !important;
}

.el-dialog__body {
  text-align: center !important;
}
</style>
